/*
  话术树
  type:类型(解析模板/话术模板/附件/宝藏/培训/制度/其他)
  keywords:关键词(小写)
  next:您是不是还想找的id
  waitInputType:下次输入内容的类型
  waitAnswerId:下次输入后返回的回答id
*/
const answers = [
  /* 新tree */
  // hello
  {
    id: '00',
    name: 'hello',
    keywords: ['目录'],
    text: '请问您是要做以下事情吗？',
    children: [
      { id: '01', label: '新增（需要填写的）' },
      { id: '02', label: '查找信息' },
      { id: '03', label: '16个猎头场景相关' },
      { id: '04', label: '模板' },
      { id: '15', label: '培训材料' },
      { id: '14', label: '系统功能' },
      { id: '16', label: '公司制度' },
    ],
  },
  {
    id: '01',
    name: '新增',
    text: '请问您是要做以下事情吗？',
    children: [
      { id: '1-7', label: '新建项目' },
      { id: '1-1', label: '新建公司' },
      { id: '2-7', label: '填写客户沟通备注' },
      { id: '5-1', label: '填写人选沟通备注' },
      { id: '2-2', label: '公司阿尔法认知' },
      { id: '2-1', label: '公司职能模块认知' },
      { id: '01-9', label: '新增情报' },
      { id: '3-1', label: '填写客户会面' },
      { id: '20-1', label: '新增人选' },
      { id: '20-2', label: '新增通讯录' },
      { id: '20-3', label: '新增职能模块报告' },
    ],
  },
  { id: '01-9', name: '新增情报', keywords: ['新增情报', '新建情报', '情报', '新增', '新建'] },
  {
    id: '02',
    name: '查找信息',
    text: '请问您是要做以下事情吗？',
    children: [
      { id: '9-5', label: '招聘信息' },
      { id: '9-4', label: '情报' },
      { id: '2-3', label: '客户公司薪酬职级' },
      { id: '3-3', label: '市场薪酬' },
      { id: '2-5', label: '人才流入流出' },
      { id: '14-1-4', label: '知识库' },
      { id: '2-9', label: '通讯录' },
      { id: '14-1-5', label: '客户合作回顾统计' },
      { id: '14-1-2', label: '推荐历史' },
      { id: '2-4', label: '公司高管' },
      { id: '2-8', label: '面试地址' },
      { id: '10-3', label: '推荐须知' },
      { id: '18', label: '进入情报系统' },
      { id: '5', label: '找候选人' },
      { id: '2', label: '找公司' },
      { id: '6', label: '找项目' },
      { id: '19', label: '学校list' },
      { id: '21', label: '认知汇总' },
      { id: '1-13', label: '137' },
      { id: '1-14', label: '331' },
      { id: '1-15', label: '公司介绍' },
    ],
  },
  {
    id: '03',
    name: '16个猎头场景相关',
    text: '请问您是要做以下事情吗？',
    children: [
      { id: '1', label: '去BD' },
      { id: '2', label: '了解一家客户' },
      { id: '3', label: '去拜访客户' },
      { id: '4', label: '筛选简历找人' },
      { id: '5', label: '查看一个候选人' },
      { id: '6', label: '找个项目' },
      { id: '7', label: '给人打个电话' },
      { id: '8', label: '去mapping' },
      { id: '9', label: '去拜访人选' },
      { id: '10', label: '推荐人选' },
      { id: '11', label: '拟offer了' },
      { id: '11-2', label: '背景调查' },
      { id: '12', label: '做离职辅导' },
      { id: '13', label: '开票' },
      { id: '14', label: '了解系统功能' },
      { id: '15', label: '学习一下业务' },
    ],
  },
  {
    id: '04',
    name: '模板',
    text: '请问您是要找以下模板吗？',
    children: [
      { id: '04-1', label: 'BD相关' },
      { id: '10-1', label: '推荐邮件' },
      { id: '10-5', label: '试单推荐邮件' },
      { id: '10-2', label: '独家委托' },
      { id: '10-4', label: '推荐确认' },
      { id: '11-1', label: '承诺书' },
      { id: '11-2', label: '背景调查' },
      { id: '12-1', label: '离职辅导' },
      { id: '12-2', label: '辞职信' },
      { id: '13-1', label: '开票邮件' },
      { id: '13-2', label: '催款邮件' },
      { id: '1-6', label: '阿尔法合同' },
      { id: '17-1', label: '面试安排模板' },
      { id: '17-2', label: '面试反馈模板' },
      { id: '17-3', label: '每日复盘模板' },
      { id: '17-4', label: '项目进展review模板' },
    ],
  },
  {
    id: '04-1',
    name: 'BD相关',
    text: '小阿为您准备了：',
    children: [{ id: '1-4', label: 'BD邮件模版' }, { id: '1-5', label: 'BD电话话术' }, { id: '1-2', label: 'BD材料' }],
  },
  /* 旧tree */
  // menu
  {
    id: '0',
    name: 'menu',
    keywords: ['菜单', '首页', '你好'],
    text: '请问您是要做以下事情吗？',
    children: [
      { id: '1', label: '去BD' },
      { id: '2', label: '了解一家客户' },
      { id: '3', label: '去拜访客户' },
      { id: '4', label: '筛选简历找人' },
      { id: '5', label: '查看一个候选人' },
      { id: '6', label: '找个项目' },
      { id: '7', label: '给人打个电话' },
      { id: '8', label: '去mapping' },
      { id: '9', label: '去拜访人选' },
      { id: '10', label: '推荐人选' },
      { id: '11', label: '拟offer了' },
      { id: '12', label: '做离职辅导' },
      { id: '13', label: '开票' },
      { id: '14', label: '了解系统功能' },
      { id: '15', label: '学习一下业务' },
      { id: '16', label: '知道公司制度' },
    ],
  },
  {
    id: '21',
    type: '其他',
    name: '认知汇总',
    keywords: ['职能模块介绍', '职能介绍', '职能认知', '认知汇总', '职能模块', '认知', '汇总', '职能'],
  },
  // bd
  {
    id: '1',
    name: '去BD',
    keywords: ['去bd'],
    text: '要去BD？小阿为您准备了：',
    children: [
      { id: '1-1', label: '新建公司' },
      { id: '1-2', label: 'BD材料' },
      { id: '2', label: '客户公司详情' },
      { id: '1-4', label: 'BD邮件模版' },
      { id: '1-5', label: 'BD电话话术' },
      { id: '1-6', label: '阿尔法合同' },
      { id: '1-7', label: '新建项目' },
      { id: '1-10', label: 'BD准备' },
    ],
  },
  {
    id: '1-1',
    type: '解析模板',
    name: '新建公司',
    keywords: [
      '新建公司',
      '创建公司',
      '建立公司',
      '新建模版',
      '公司模版',
      '填写公司信息',
      '新建公司模版',
      '新建',
      '创建',
      '公司',
    ],
  },
  { id: '1-2', type: '其他', name: 'BD材料', keywords: ['bd', 'bd材料', '投标'] },
  {
    id: '1-4',
    type: '话术模板',
    name: 'BD邮件',
    label: 'BD邮件模板',
    keywords: ['bd邮件模版', 'bd邮件', 'bd', '邮件', '话术', '模板'],
    content:
      '<p>XX总，您好，\n\n        我是XXX，阿尔法咨询金融猎头，专做 金融行业（如果知道他们最近紧急招的职位，正好是你擅长的模块，就可以具体到大的职能模块） 岗位高端招聘，\n\n        先介绍一下我们公司，\n\n        区别于传统猎头公司，阿尔法咨询是一家极具特色的人工智能AI猎头公司，专业专注金融领域，在业内外好评如潮!目前,我们合作的客户都是金融业翘楚或者快速发展机构。比如【XXX、XXX、XXX、XXX、XXX、XXX、XXX、XXX、XXX、XXX、XXX】等（请填写自己版块内的优质客户）。\n\n        我司成立5年多时间，现有人员40余人。【此处请加粗自己版块的业务细分】主要专注的方向有：PEVC股权投资（财务投资/FA/战略投资），一二级投研（权益、固收、量化、FOF），创新业务（ABS、夹层、投资者关系，股权投后管理等），机构销售，风控法务合规财务人力等中后台职位（这些板块基本覆盖全市场80-90%的人选）。依托于清华大学+伯克利研发团队自主研发的人工智能AI评价系统，极大的提高猎头服务的推荐速度。对于客户需求，进行精准匹配，一般2天内可以覆盖市场80%的人选，1周内可以出具市场搜寻报告给人力和业务领导参考！详细可查阅附件《阿尔法公司介绍》\n\n        此外，我司还有很多免费的增值服务。比如：公众号“阿尔法咨询”每两周发布金融行业市场动态，助力人力轻松了解大家最关心的市场信息，以及阶段性市场热点问题专题解读。我们会提供薪酬、组织结构、人才流动统计等各种类型报告，最值得一提的是，我们每年还会倾力推出一次金融市场人才招聘报告，详细内容可参见《2019年金融市场人才招聘报告》，更加能够展示出我们深耕行业多年的专业度。\n\n        附上我司合同，供您参考.\n\n        希望能有机会与贵司交流学习，建立深厚的合作关系。\n\n        期待您的回复，\n        谢谢！</p>',
  },
  {
    id: '1-5',
    type: '话术模板',
    name: 'BD电话',
    label: 'BD电话话术',
    keywords: ['bdcall', 'bd电话话术', 'bd话术', 'bd电话', 'bd', '话术', '模板'],
    hasStyle: true,
    content: `<p><div style="color:#aaa">一、金融相关行业</div>
【金融通用-对业务老大】<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;X总，我是专注于金融领域的猎头，之间对您一直长期跟踪，您是行业大佬，尤其在 XX 领域，XX 等等方向，XX公司能有您，也是非常荣幸，而且我也特别希望有机会能够给您招人。而且我也关注到最近行业热点（说新业务），咱们一定也有部署这一块业务的打算……（对X 总的认可对行业很熟，表达了合作意向， 引出合作方向）
<br><br>
【金融通用-对 HR 】<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;X总您好，我是阿尔法咨询的顾问，多年专注于【你BD客户的所在领域】领域的猎头，之前一直很想和您合作，正好近期有关注到咱们在找【…客户在寻找的领域人才】方面的人才，在这个领域里，阿尔法深耕多年，也合作了一些非常头部的客户公司【行业top公司，华夏，嘉实，汇添富基金】等等，刚好我们在这方面有充足的人才储备，我们也长期跟踪这个市场上最优秀的【客户要找的人才】的动向，也都很熟悉～咱们现在在招的这位是不是也是要看长期稳定业绩好的人选呢？……（可以点出几个人的名字），您感兴趣的话，如果我有幸帮您寻找人才的话，基于阿尔法特有的人工智能系统的智能匹配人选我可以在半个小时之内帮您出具报告和合适人选（阿尔法体系化打法），这样可以第一时间帮您了解市场全貌…如果您感兴趣的话，我们一定周末约个咖啡吧，怎么样～会是一段愉快的合作旅程的～
<br><br>
<div style="color:#aaa">二、医疗相关行业</div>
【医药通用-微信或电话话术】<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;X总您好，我是阿尔法咨询的业务总监【xxx】，是长期专注在金融与医药领域的猎头。我们是一家基于数字化赋能的新锐猎头公司。目前我们在医药医疗领域做了些独特的积累：<br>
1、可以为您提供细分领域的的薪酬数据方便您查阅<br>
2、我们还长期跟踪市场上最优秀的人选并做成市场流动分析<br>
3、我们在海外建立了专门的团队对华人科学家做针对的搜索并与国内优秀的biotech的创业公司合作。<br>
<br>
阿尔法擅长招聘医药垂直行业的各项岗位，包含R&D、Medical及Operation等领域岗位，以及药企战略、BD、股权投资、董秘/CFO等职能岗位。深谙各类平台的人才偏好和阶段性人才需求，对于各家策略打法和考核激励都有深入研究，能够针对性提供全方位业务和人才解决方案。同时我们的顾问都具备高学历，90%是海归且有很强的钻研精神，非常期待能够配合您的工作。
<br><br>
【医药PEVC-投资人/FA话术】<br>
Hi xx总~最近团队新做了一些工具和您分享，也想和您请教：<br>
1、您近期有了解，刚融到资又比较优秀的A/B轮企业吗?<br>
2、我们搭建的专做医药医疗猎头团队，在美国还搭建了一个团队，重点布局了海外的科学家库，以及已经回国担任CMO的人群，不知道您们投资的机构近期是否有招聘需求，能否帮忙引荐创始人?
<br><br>
我们还也在医药医疗领域做了些独特的积累，比如可以为您的被投企业提供细分领域的的薪酬数据方便查阅，以下是刚做好的医药薪酬查询产品，也第一时间分享给您试用~<br>
（分享圆手小程序医药行业查薪酬给对方）
<br><br>
【医药-朋友圈话术】<br>
医药医疗投资人想回归产业&被投企业招聘看这里！<br>
<br>
我们观察到【】月份以来，医疗与生命科技投资赛道热度下降非常明显。国内企业私募融资、境外二级市场融资、并购等方向交易数量都达到今年来的新低。因此：
<br><br>
1、如果您是医疗投资人，想回归产业，欢迎小窗我想看的细分赛道/对标机构。
<br><br>
2、如果您的被投企业有招聘需求，欢迎扫下方二维码联系我司专门搭建的医药医疗猎头团队。我们在美国还搭建了专门的支持中心，重点布局了海外的科学家库，以及已经回国担任CMO的人群。
<br><br>
可提供招聘支持包括：mRNA疫苗/细胞疗法/基因疗法/罕见病等多个核心领域，医学/Operation/R&D等职位领域。</p>`,
  },
  {
    id: '1-6',
    type: '附件',
    name: '阿尔法合同',
    keywords: ['合同', '阿尔法合同'],
    attachments: [
      {
        title: '阿尔法合同',
        md5: '2f9150c8171e3527beb4fd1e81882df7',
      },
    ],
  },
  {
    id: '1-7',
    type: '解析模板',
    name: '新建项目',
    keywords: [
      '新建项目',
      '创建项目',
      '建立项目',
      '新建模版',
      '项目模版',
      '填写项目信息',
      '新建项目模版',
      '新建',
      '创建',
      '公司',
    ],
  },
  {
    id: '1-8',
    type: '附件',
    name: '营业执照',
    keywords: ['营业执照'],
    attachments: [
      {
        title: '浙江阿尔法营业执照',
        md5: '3eae31e9c9d31ab88d1252e9b0ad2ef8',
      },
    ],
  },
  {
    id: '1-9',
    type: '附件',
    name: '人力资源许可证',
    keywords: ['人力资源', '许可证'],
    attachments: [
      {
        title: '人力资源许可证',
        md5: 'e7161d02127ee2483fc9d4cbc4e074bb',
      },
    ],
  },
  {
    id: '1-10',
    name: 'BD准备',
    keywords: ['bd准备'],
    text: '想看哪家公司BD准备？输入公司简称，小阿为您秒开～',
    waitInputType: '公司',
    waitAnswerId: '3-1',
  },
  {
    id: '1-11',
    type: '附件',
    name: '市场报告',
    keywords: ['市场报告'],
    attachments: [
      {
        title: '市场报告',
        md5: 'b7f028aeaf4d7ae8de783201f4f83a2b',
      },
    ],
  },
  {
    id: '1-12',
    type: '附件',
    name: '项目小结',
    keywords: ['项目小结'],
    attachments: [
      {
        title: '项目小结',
        md5: '4c5088ef869763c8324c24f52089ea95',
      },
    ],
  },
  { id: '1-13', type: '其他', name: '137', keywords: ['137', '一三七', '做单节奏', '推荐节奏', '节奏'] },
  { id: '1-14', type: '其他', name: '331', keywords: ['331', '三三一'] },
  {
    id: '1-15',
    type: '附件',
    name: '公司介绍',
    label: '公司介绍',
    keywords: ['公司介绍', '阿尔法介绍'],
    attachments: [
      {
        title: '阿尔法公司介绍',
        md5: '45f191c4689954e01f1cf56c4cde9eb8',
      },
    ],
  },
  // 公司
  {
    id: '2',
    name: '了解一家客户',
    keywords: ['客户', '公司', '了解客户', '了解公司', '查看客户', '查看公司'],
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    waitInputType: '公司',
    waitAnswerId: '2-0',
  },
  {
    id: '2-0',
    name: 'company',
    text: '您可以直接点击查看该公司的：',
    children: [
      { id: '2-1', label: '职能模块认知' },
      { id: '2-2', label: '阿尔法认知' },
      { id: '2-3', label: '薪酬职级' },
      { id: '2-4', label: '公司高管' },
      { id: '10-3', label: '推荐须知' },
      { id: '2-5', label: '人才流入流出' },
      { id: '2-8', label: '面试地址' },
      { id: '2-7', label: '填写客户沟通备注' },
      { id: '9-4-0', label: '公司情报' },
      { id: '2-6', label: '直接打开详情页' },
    ],
  },
  {
    id: '2-1',
    name: '公司职能模块认知',
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    keywords: ['职能模块认知', '部门认知', '部门情况', '职能模块', '部门架构', '架构', '职能', '认知'],
    waitInputType: '公司',
    waitAnswerId: '2-1-0',
  },
  { id: '2-1-0', type: '其他', name: '公司职能模块认知' },
  {
    id: '2-2',
    name: '公司阿尔法认知',
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    keywords: ['阿尔法认知', '公司认知', '阿尔法', '认知'],
    waitInputType: '公司',
    waitAnswerId: '2-2-0',
  },
  { id: '2-2-0', type: '其他', name: '公司阿尔法认知' },
  {
    id: '2-3',
    name: '公司薪酬职级',
    label: '客户公司薪酬职级',
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    keywords: ['奖金', '绩效', '钱', '薪酬职级', '薪酬', '职级'],
    waitInputType: '公司',
    waitAnswerId: '2-3-0',
  },
  { id: '2-3-0', type: '其他', name: '公司薪酬职级' },
  {
    id: '2-4',
    name: '公司高管',
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    keywords: ['高管介绍', '高管架构', '组织架构', '高管'],
    waitInputType: '公司',
    waitAnswerId: '2-4-0',
  },
  { id: '2-4-0', type: '其他', name: '公司高管' },
  {
    id: '2-5',
    name: '人才流入流出',
    text: '想看哪家公司人才流入流出？输入公司简称，小阿为您秒开～',
    keywords: ['人才流动', '流入流出', '人才来源', '人才流入流出', '人员变动', '流入', '流出', '流动'],
    waitInputType: '公司',
    waitAnswerId: '2-5-0',
  },
  { id: '2-5-0', type: '其他', name: '人才流入流出' },
  {
    id: '2-7',
    name: '客户沟通备注',
    text: '想看哪家客户？输入公司简称，小阿为您秒开～',
    keywords: ['客户沟通', '客户进展', '客户'],
    waitInputType: '公司',
    waitAnswerId: '2-7-0',
  },
  { id: '2-7-0', type: '其他', name: '客户沟通备注' },
  { id: '2-6', name: '打开公司详情页', isLink: true },
  {
    id: '2-8',
    name: '面试地址',
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    keywords: ['面试地址', '地址'],
    waitInputType: '公司',
    waitAnswerId: '2-8-0',
  },
  { id: '2-8-0', type: '其他', name: '面试地址' },
  {
    id: '2-9',
    name: '公司通讯录',
    text: '想看哪家公司？输入公司简称，小阿为您秒开～',
    keywords: ['通讯录'],
    waitInputType: '公司',
    waitAnswerId: '2-9-0',
  },
  { id: '2-9-0', name: '公司通讯录', isLink: true },
  // 客户会面
  {
    id: '3',
    name: '拜访客户',
    text: '拜访客户别忘了做好准备～小阿为您准备了：',
    keywords: ['见客户', '拜访客户', '客户见面'],
    children: [
      { id: '3-5', label: '会面准备' },
      { id: '3-1', label: '客户会面记录' },
      { id: '3-2', label: '客户公司介绍及高管' },
      { id: '3-3', label: '查看市场薪酬' },
      { id: '3-4', label: '客户管理' },
      { id: '2-7', label: '填写客户沟通备注' },
      { id: '1-7', label: '新建项目' },
    ],
  },
  {
    id: '3-1',
    type: '解析模板',
    name: '客户会面',
    label: '客户会面记录',
    keywords: ['客户会面', '见客户', '客户', '会面', '拜访'],
  },
  {
    id: '3-2',
    name: '客户公司介绍及高管',
    text: '想看哪家公司介绍？输入公司简称，小阿为您秒开～',
    waitInputType: '公司',
    waitAnswerId: '3-2-0-0',
  },
  {
    id: '3-2-0',
    name: '再次查找公司',
    text: '想看哪家公司介绍？输入公司简称，小阿为您秒开～',
    waitInputType: '公司',
    waitAnswerId: '3-2-0-0',
  },
  { id: '3-2-0-0', type: '其他', name: '客户公司介绍及高管' },
  { id: '3-3', type: '其他', name: '市场薪酬', keywords: ['市场薪酬', '行业薪酬', '市场', '薪酬'] },
  {
    id: '3-4',
    name: '客户管理',
    keywords: ['客户管理', '客户列表', '客户'],
    path: 'clientManage',
    isLink: true,
  },
  {
    id: '3-5',
    name: '会面准备',
    keywords: ['会面准备'],
    text: '想看哪家公司会面准备？输入公司简称，小阿为您秒开～',
    waitInputType: '公司',
    waitAnswerId: '3-1',
  },
  // 搜人
  {
    id: '4',
    name: '筛选简历找人',
    text: '筛选简历您可能需要用到以下界面：',
    keywords: ['找人', '筛选简历', '拉人', '找简历', '在人才库搜人'],
    children: [{ id: '4-1', label: '人才快搜界面' }, { id: '14-1-1', label: '通讯录界面' }],
  },
  {
    id: '4-1',
    type: '宝藏',
    name: '如何查找人选',
    keywords: ['人才快搜', '搜索人选', '人选搜索', '搜索人才', '人才搜索', '找人'],
  },
  // 人选
  {
    id: '5',
    name: '查看候选人',
    keywords: ['查看候选人', '查看人选', '候选人', '搜人', '人选'],
    text: '告诉小阿您要找哪个人选，我来帮您找～',
    waitInputType: '人选',
    waitAnswerId: '5-0',
  },
  {
    id: '5-0',
    name: 'radish',
    text: '查到啦！您要对ta做些什么呢？',
    children: [
      { id: '5-1', label: '填写沟通备注' },
      { id: '5-2', label: '填写人选会面' },
      { id: '5-3', label: '有干货！填一下职能模块认知' },
      { id: '5-4', label: '挖到料了！填一下阿尔法认知' },
      { id: '5-5', label: '查看详情' },
    ],
  },
  {
    id: '5-1',
    name: '沟通备注',
    label: '填写人选沟通备注',
    keywords: ['电话沟通', '沟通备注', '沟通'],
    text: '告诉小阿您要找哪个人选，我来帮您找～',
    waitInputType: '人选',
    waitAnswerId: '5-1-0',
  },
  {
    id: '5-1-0',
    type: '解析模板',
    name: '沟通备注',
  },
  { id: '5-2', type: '解析模板', name: '人选会面', label: '填写人选会面记录', keywords: ['人选会面', '会面', '见人'] },
  {
    id: '5-3',
    name: '职能认知',
    label: '人选职能模块认知',
    keywords: ['职能模块认知', '认知'],
    text: '告诉小阿您要找哪个人选，我来帮您找～',
    waitInputType: '人选',
    waitAnswerId: '5-3-0',
  },
  { id: '5-3-0', type: '解析模板', name: '职能认知' },
  {
    id: '5-4',
    name: '阿尔法认知',
    label: '人选阿尔法认知',
    keywords: ['阿尔法认知', '公司认知', '认知'],
    text: '告诉小阿您要找哪个人选，我来帮您找～',
    waitInputType: '人选',
    waitAnswerId: '5-4-0',
  },
  {
    id: '5-4-0',
    type: '解析模板',
    name: '阿尔法认知',
  },
  { id: '5-5', name: '打开人选详情页', isLink: true },
  // 项目
  {
    id: '6',
    name: '查看项目',
    keywords: ['查看项目', '找项目', '项目'],
    text: '输入项目名称，小阿来帮您找～',
    waitInputType: '项目',
  },
  {
    id: '6-0',
    name: '再次查找项目',
    text: '输入项目名称，小阿来帮您找～',
    waitInputType: '项目',
  },
  // 打电话
  {
    id: '7',
    name: '给人打电话',
    text: '明白～马上要打电话了，您现在需要：',
    keywords: ['见客户', '拜访客户', '客户见面'],
    children: [
      { id: '5', label: '寻找一个候选人' },
      { id: '6', label: '职位介绍' },
      { id: '3-3', label: '查看市场薪酬' },
    ],
  },
  // mapping
  {
    id: '8',
    name: '去mapping',
    text: '小阿猜到Mapping时您可能需要：',
    keywords: ['mapping'],
    children: [{ id: '3-2', label: '客户公司介绍及高管' }, { id: '2', label: '进入公司详情' }],
  },
  // 人选会面
  {
    id: '9',
    name: '拜访人选',
    text: '拜访人选时您可能需要以下几项：',
    keywords: ['拜访人选', '见人'],
    children: [
      { id: '5-2', label: '填写人选会面记录' },
      { id: '3-2', label: '客户公司介绍及高管' },
      { id: '14-1-1', label: '查看通讯录' },
      { id: '9-4', label: '公司的情报' },
    ],
  },
  {
    id: '9-4',
    name: '公司的情报',
    keywords: ['公司情报', '情报', '变动'],
    text: '想看哪家公司的情报？输入公司简称，小阿为您秒开～',
    waitInputType: '公司',
    waitAnswerId: '9-4-0',
  },
  {
    id: '9-4-0',
    name: '打开公司情报页',
    isLink: true,
    activeTab: 'Information',
  },
  { id: '9-5', type: '其他', keywords: ['招聘', '信息'], name: '招聘信息' },
  // 推荐
  {
    id: '10',
    name: '了解推荐事项',
    label: '推荐人选',
    keywords: ['推荐人选', '推人', '推荐'],
    text: '推荐人选可能会用到：',
    children: [
      { id: '10-1', label: '推荐人选邮件模版' },
      { id: '10-2', label: '独家委托模版' },
      { id: '10-3', label: '推荐须知' },
      { id: '10-4', label: '推荐确认模板' },
      { id: '10-5', label: '试单推荐模板' },
    ],
  },
  {
    id: '10-1',
    type: '话术模板',
    name: '推荐邮件',
    label: '推荐邮件模板',
    keywords: ['推荐邮件', '推荐', '邮件', '话术', '模板'],
    content:
      '<p>【收件人姓名】总：\n        您好！\n        向【公司名称】【XX岗位】推荐【人数】位优秀人选，其中【候选人名】，【候选人名】为重点推荐。\n\n        1、【候选人名】【人选目前公司】【目前职位】\n        人选优势【主要优势点】，业绩【业绩情况】，【其他优势;软性特质】\n        2、【候选人名】【人选目前公司】【目前职位】\n        人选优势【主要优势点】，业绩【业绩情况】，【其他优势;软性特质】\n\n        人选意向积极，建议尽快安排沟通。详情参见附件。\n    </p>',
  },
  {
    id: '10-2',
    type: '话术模板',
    name: '独家委托',
    label: '独家委托模板',
    keywords: ['独家委托', '独家', '委托', '话术', '模板'],
    content:
      '<p>Dear 【xx经理/总】\n        独家委托内容如下，供您参考：\n\n        关于【xx公司】的【xx职位】，第一次正式与我联系的是猎头顾问【xxx】，与我详细沟通职位情况后，我对该职位非常感兴趣并独家委托她/他帮我推荐运作，我认可【xxx】的推荐，希望由她/他帮我安排后续流程。\n        </p>',
  },
  {
    id: '10-3',
    name: '推荐须知',
    text: '想看哪家公司的推荐须知？输入公司简称，小阿为您秒开～',
    keywords: ['推荐须知'],
    waitInputType: '公司',
    waitAnswerId: '10-3-0',
  },
  { id: '10-3-0', type: '其他', name: '推荐须知' },
  {
    id: '10-4',
    type: '话术模板',
    name: '推荐确认',
    label: '推荐确认模板',
    keywords: ['推荐确认', '推荐', '话术', '模板'],
    content:
      '<p>正如我们电话沟通的，XX公司的XX职位，经得您的同意，我会正式帮您推荐，这个职位您也唯一委托我，后续推进流程将由我独家进行操作，对吧？</p>',
  },
  {
    id: '10-5',
    type: '话术模板',
    name: '试单推荐邮件',
    label:  '试单推荐邮件模板',
    keywords: ['试单', '推荐邮件', '推荐', '邮件', '话术', '模板'],
    content:
      '<p>【收件人姓名】总：\n        您好！\n        向【公司名称】【XX岗位】推荐【人数】位优秀人选，其中【候选人名】，【候选人名】为重点推荐。\n\n        1、【候选人名】【人选目前公司】【目前职位】\n        人选优势【主要优势点】，业绩【业绩情况】，【其他优势;软性特质】\n        2、【候选人名】【人选目前公司】【目前职位】\n        人选优势【主要优势点】，业绩【业绩情况】，【其他优势;软性特质】\n\n        人选意向积极，建议尽快安排沟通。详情参见附件。\n\n试单温馨提示：\n    感谢您的信赖并给予XXX（以下简称阿尔法咨询）试单以建立合作关系的机会！\n    在试单期间，请贵司在阿尔法咨询推荐候选人简历后的2个工作日内回复意见，不回复的可视为贵司同意阿尔法咨询试单条件及推荐。\n    试单期间，候选人一经贵司录用，请在发放人员录用通知后的一周内与阿尔法咨询签订合作协议并按协议支付相应费用。\n    期待成功合作并为贵司提供长期服务。</p>',
  },
  // offer
  {
    id: '11',
    name: '拟offer相关',
    keywords: ['拟offer', '谈offer', 'offer'],
    text: '拟offer可能会用到：',
    children: [{ id: '11-1', label: '承诺书模版' }, { id: '11-2', label: '背景调查模版' }],
  },
  {
    id: '11-1',
    type: '话术模板',
    name: '承诺书',
    label: '承诺书模版',
    keywords: ['承诺书', '承诺', '话术', '模板'],
    content:
      '<p>本人对【XX基金】【2019年9月10日】给予的职位口头offer认可，并正式接受offer。\n\n        本人承诺将全力配合完成剩下的offer流程，并在【2019年10月8日】向公司正式发起离职流程。届时如果因为考虑其他职位机会、现公司挽留、家庭原因、个人意向变化等因素，无法入职【XX基金】，本人将承担由于本人所违约造成的相关损失。\n      </p>',
  },
  {
    id: '11-2',
    type: '附件',
    name: '背景调查',
    label: '背景调查模版',
    keywords: ['背景调查', '背调', '模板'],
    attachments: [
      {
        title: '背景调查模板',
        md5: '4897bb93dd3a9dbb7b5e00b48bfe85a9',
      },
    ],
  },
  // 离职
  {
    id: '12',
    name: '离职辅导',
    text: '离职辅导可能会用到：',
    children: [{ id: '12-1', label: '离职辅导话术' }, { id: '12-2', label: '辞职信模板' }],
  },
  {
    id: '12-1',
    type: '话术模板',
    name: '离职辅导',
    label: '离职辅导话术',
    keywords: ['离职辅导', '离职', '话术', '模板'],
    content:
      '<p>        一、 离职是个耗费心力的痛苦过程，越优秀的人，越离职困难，过程也越艰辛。（经常有人把离职比作一次分手，心力交瘁）\n\n        二、 心态和心理建设非常重要，离职到最后真的拼的是韧性，比挽留者、阻力方，心理上更坚决一些（不一定是表面的态度）、更理性一些，想得更多一层，更深一层。\n\n        三、 周密规划，不打没有准备的战，想好理由（需要反复推敲），写好离职信，离职信要准备至少三封，分三个阶段：\n\n              1） 初期提出阶段：第一封是写给直线领导（或者是直线的直线，平时业务上关系最密切），用微信发，告诉要离职的情况，理由一定要在理，而且最后是让领导无法拒绝的理由，有客观情况支撑的，切记一定不要是说去竞争对手公司，最好是离开这个行业了，比如回党校，或者会政府机构，或者是事业单位，或者是一些跟个人爱好相关的创业等等，同时要强调是跟目前阶段身体或家里的一些原因，希望转换行业，并且是跟家里人商量过的，深思熟虑的。同时一定要大篇幅感谢这位领导，而且要感谢到实的点上，真实的经历，领导真实的一些帮助，优点等等，不要空大话。强调离开了情意还在，一辈子的领导。然后找领导当面谈，再陈述理由，同时表示一定会好好做好交接工作，对公司和部门不造成任何任何不好的影响。\n\n              2） 焦灼期：第二封信，是前面一封信发出后，跟领导谈过多次，进入焦灼阶段后发出的。第一封信发出后，大部分时候，领导都不同意，会反复做思想工作，而且会给出很多承诺，比如加固定薪酬，升职级，承诺给出更多的奖金等等，如果不奏效，就会用拖字诀，或者是打压给压力的方法。领导会希望领导主动放弃离职。如果是给出更好的条件，不要当场拒绝，回去后过1-2天，再发第二次离职信，如果是拖也是发出第二封，还是要态度坚决，说自己想好了，再次感谢领导，同时请领导成全。如果是打压，给压力，那么好要继续跟领导面谈，吃饭也好，办公室门口等着也好，当面表达很无奈但是非离开不可，求领导成全，同时多赞美领导。领导口松了，再发第二封信。\n\n              3） 一锤定音：第三封信，是跟领导当面沟通，沟通过多次，反复做思想工作，已经做通，领导同意离职后，再通过公司邮箱发出书面的离职信（虽然很多公司离职是走OA流程，但是这个通过公司邮箱发书面的离职信非常重要，这个劳动法认可的，将来对自己的一个证明和保障。）这封信有比较固定的模版可以提供。\n\n        四、 经常出现的问题：\n\n              1） 被领导糖衣炮弹挽留，一提离职，领导开出一堆好的条件，就心软了，觉得自己不用离职就达到了想要的条件，开心留下了。根据统计，一般这样留下来的，大部分半年之内又会离开。因为如果领导真的能那么那么容易给出这些条件，那么不用离职早就给了，如果是用离职来拿到的，会非常微妙。你提离职的时候，领导都是想着你的好，你走了以后公司的损失，所有的想法都是想怎么挽留，不计手段和成本，但是这样会打破平衡，打破常规。一旦不走了，领导的想法就变了，这个难关过了，领导就开始秋后算账了，首先提过离职，双方信任感已经有些有些问题了，其次，原来没有给的条件给了，但是领导会觉得有些被胁迫了，会很不情愿，会打折扣，或者勉强给了，也会容易招致其他其他同事的意见，最后领导很难办，所有的帐都会记在提离职的人身上，迟早迟早要还的。所以一旦提出离职，就要坚决，内心非常坚定，不要回头，不要被影响。\n\n              2） 做法太粗暴。虽然内心坚决，但是做法一定要温和，最好找一个领导非常能接受的理由。这个很重要，不要强硬离职，要把自己放到领导位置考虑，怎么让他舒服怎么来。感情上接受了，理性上慢慢就接受了。最怕闹僵了，会非常不愉快，而且可能就无法离职成功了。\n\n              3） 孤军奋战，被一堆人来不断做说客说服。我们要动用所有可以动用的力量，领导的朋友，外部的资源，内部的同事，不要让他们变成领导或者公司的说客，而是变成接受你离职的既定事实，帮你去慢慢影响决策者（请吃饭，谈交情，送个礼物等等都会有作用）。\n\n        五、 一些供参考的文章（见微信链接）\n\n        六、 前面三封离职信的一些参考真实案例，我们可以提供，也可以商量好了以后，我们一起来成文。\n      </p>',
  },
  {
    id: '12-2',
    type: '话术模板',
    name: '辞职信',
    label: '辞职信模板',
    keywords: ['辞职信', '辞职', '离职', '话术', '模板'],
    content:
      '<p>                                                           辞 职 申 请\n      尊敬的XX领导：  \n              您好！  \n              首先，我感觉非常的抱歉和遗憾，由于个人职业规划和一些现实因素，经过慎重考虑之后，特此提出离职申请，敬请批准。  \n              在公司工作X年多的时间里，我有幸得到了各位领导及同事们的倾心指导及热情帮助，在本职工作和路桥专业技能上，我得到了很大程度的提高，在此感谢贵公司提供给我这个良好的平台，这X年多的工作经验将是我今后职业生涯中的一笔宝贵财富。    \n              在这里，特别感谢各位领导在过去的工作、生活中给予的大力支持与帮助;尤其感谢科室主任曾工和科室里的老员工和新同事，X年来对我的信任和关照，在这里感谢所有给予过我帮助的同事们。在这里真心的说声谢谢！  \n              望公司领导批准我的申请，并请协助办理相关离职手续，在正式离开之前我将认真继续做好目前的每一项工作，详细认真的配合交接工作。    \n              祝公司事业蓬勃发展，前景灿烂。\n              此致\n                      敬礼！\n\n                                                                                      申请人：【XXXX】\n                                                                                      【201X年X月X日】\n    </p>',
  },
  // 开票
  {
    id: '13',
    name: '开票',
    text: '开票可能会用到：',
    children: [{ id: '13-1', label: '开票邮件模板' }, { id: '13-2', label: '催款邮件模板' }],
  },
  {
    id: '13-1',
    type: '话术模板',
    name: '开票邮件',
    label: '开票邮件模板',
    keywords: ['开票', '邮件', '话术', '模板'],
    content:
      '<p>Dear ,\n        您好！感谢您一直以来对阿尔法的信任和支持！\n        【XXX】岗人选【XXX】已于【XXX年XX月XX日】到岗；附件是（如果有分期，就告知具体第几期）付款通知书，烦请核对金额和相关信息，我们将据此开具发票与付款通知书一并邮寄给您（如果是第一次开票：烦请您方便的时间回复贵司的开票信息、费用类别等）。\n        感恩能与贵司一路相随，一起成长！\n        也祝愿贵司业务一切顺利，节节攀升！\n      </p>',
  },
  {
    id: '13-2',
    type: '话术模板',
    name: '催款邮件',
    label: '催款邮件模板',
    keywords: ['催款', '邮件', '话术', '模板'],
    content:
      '<p>XX顾问：\n          您好！\n          您所负责的客户：【XXXXXXXXXXXX】，我们推荐了【XXX】岗位人选【XXX】。人员已经正式到岗，付款通知书和发票已经于【XX月XX日】寄出。\n          根据合同约定，客户已到付款时间，还请跟进付款情况并告知具体可以付款的时间。以免影响您的业绩考核以及跟客户的合作。\n        谢谢！\n      </p>',
  },
  // 系统
  {
    id: '14',
    name: '了解系统功能',
    keywords: ['系统', '功能', '教学'],
    text: '请问您想了解以下哪项呢：',
    children: [{ id: '14-1', label: '系统功能介绍' }, { id: '14-2', label: '系统使用教学' }],
  },
  {
    id: '14-1',
    name: '系统功能介绍',
    text: '请问您是想了解：',
    children: [
      { id: '14-1-1', label: '如何查看通讯录' },
      { id: '14-1-2', label: '如何最快找到合适人选' },
      { id: '14-1-3', label: '如何查看人才流动' },
      { id: '14-1-4', label: '如何了解行业' },
      { id: '14-1-5', label: '客户合作回顾统计' },
      { id: '14-1-6', label: '如何查看KPI' },
      { id: '14-1-7', label: '如何查看体系化积分' },
      { id: '14-1-8', label: '如何查看自己的成单情况' },
      { id: '14-1-9', label: '公司血库预测' },
    ],
  },
  {
    id: '14-1-1',
    type: '宝藏',
    name: '如何查看通讯录',
    keywords: ['通讯录', 'list'],
    next: ['15-9'],
  },
  {
    id: '14-1-2',
    type: '宝藏',
    name: '如何最快找到合适人选',
    keywords: ['找人', '推荐', '合适', '适合'],
    next: ['14-2-1'],
  },
  {
    id: '14-1-3',
    type: '宝藏',
    name: '如何查看人才流动',
    keywords: ['流入流出', '人才流动', '人才动向', '流动', '流入', '流出'],
    next: ['14-2-2'],
  },
  {
    id: '14-1-4',
    type: '宝藏',
    name: '如何了解行业',
    keywords: ['了解行业', '行业知识', '知识库', '行业认知', '行业报告', '知识', '行业', '报告'],
  },
  {
    id: '14-1-5',
    type: '宝藏',
    name: '客户合作回顾统计',
    keywords: ['回顾', '盘点', 'review', '客户合作', '客户报告', '项目盘点'],
  },
  {
    id: '14-1-6',
    type: '宝藏',
    name: '如何查看KPI',
    keywords: ['kpi'],
  },
  {
    id: '14-1-7',
    type: '宝藏',
    name: '如何查看体系化积分',
    keywords: ['体系化积分', '体系化', '积分'],
  },
  {
    id: '14-1-8',
    type: '宝藏',
    name: '如何查看自己的成单情况',
    keywords: ['offer', '成单', '成了多少单'],
  },
  {
    id: '14-1-9',
    type: '宝藏',
    name: '公司血库预测',
    keywords: ['金主', '血库', '慧眼', '预测'],
  },
  {
    id: '14-2',
    name: '系统使用教学',
    text: '请问您是想了解：',
    children: [
      { id: '14-2-1', label: '推荐历史功能使用教程' },
      { id: '14-2-2', label: '人才流动统计功能使用教程' },
      { id: '14-2-3', label: '人才搜索功能使用教程' },
      { id: '14-2-4', label: '猎聘插件使用教程' },
      { id: '14-2-5', label: '市场资讯功能使用教程' },
      { id: '14-2-6', label: '查看更多教学' },
    ],
  },
  {
    id: '14-2-1',
    type: '培训',
    keywords: ['推荐历史', '教程'],
    name: '推荐历史功能使用教程',
    text: '还不知道如何使用推荐历史功能吗？看看下面的教程吧：',
    attachments: [
      {
        title: '【附件教学】推荐历史功能使用教程',
        type: 'word',
        md5: '6b80054c4a3ca012f4770a1b98d0757d',
      },
    ],
  },
  {
    id: '14-2-2',
    type: '培训',
    keywords: ['流入流出', '人才流动', '人才动向', '流动', '流入', '流出', '教程'],
    name: '人才流动统计功能使用教程',
    text: '还不知道如何使用人才流动统计功能吗？看看下面的教程吧：',
    attachments: [
      {
        title: '【附件教学】人才流动统计功能使用教程',
        type: 'word',
        md5: '749af75f34033a68467e2d7f75688198',
      },
    ],
  },
  {
    id: '14-2-3',
    type: '培训',
    keywords: ['找人', '人才搜索', '人才快搜', '人才库', '教程'],
    name: '人才搜索功能使用教程',
    text: '还不知道如何使用人才快搜吗？看看下面的教程吧：',
    attachments: [
      {
        title: '人才搜索功能使用教程',
        type: 'word',
        md5: 'c9888b156864fa1e2a44921918a07a1f',
      },
    ],
  },
  {
    id: '14-2-4',
    type: '培训',
    keywords: ['猎聘', '插件', '教程'],
    name: '猎聘插件使用教程',
    text: '还不知道如何使用猎聘插件吗？看看下面的教程吧：',
    attachments: [
      {
        title: '猎聘搜索功能使用教程',
        type: 'word',
        md5: 'a0c01955270cf5fbce258f7052c8ab3f',
      },
    ],
  },
  {
    id: '14-2-5',
    type: '培训',
    keywords: ['情报', '市场资讯', '资讯', '新闻', '变动', '教程'],
    name: '市场资讯功能使用教程',
    text: '还不了解市场资讯页面吗？看看下面的教程：',
    attachments: [
      {
        title: '市场资讯功能使用教程',
        type: 'word',
        md5: '2cc24c0b9e89a1a1fe7ddd22cfc227c8',
      },
    ],
  },
  {
    id: '14-2-6',
    path: 'catalogue/系统使用教学',
    name: '打开系统教学页',
    isLink: true,
  },
  // 业务
  {
    id: '15',
    name: '学习一下业务',
    keywords: ['业务教学', '业务', '教学', '培训'],
    text: '请问您是想了解：',
    children: [
      { id: '15-1', label: '新手教学' },
      // { id: '15-2', label: '学习行业认知' },
      { id: '15-3', label: '如何开拓新领域' },
      { id: '15-4', label: '如何开发客户' },
      { id: '15-5', label: '如何进行客户会面' },
      { id: '15-6', label: '如何快速了解项目' },
      { id: '15-7', label: '如何推动项目' },
      { id: '15-8', label: '如何进行人才搜索' },
      { id: '15-9', label: '如何快速筛选简历' },
      { id: '15-10', label: '如何打电话' },
      { id: '15-11', label: '如何Mapping' },
      { id: '15-12', label: '如何打标签' },
      { id: '15-13', label: '如何帮大佬写推报' },
      { id: '15-14', label: '如何高效进行人选会面' },
      { id: '15-15', label: '如何安排面试&面试辅导' },
      { id: '15-16', label: '如何进行人选背景调查' },
      { id: '15-17', label: '如何谈offer' },
      { id: '15-18', label: '如何离职辅导' },
      { id: '15-19', label: '如何到岗维护' },
      { id: '15-20', label: '如何获取list' },
      { id: '15-21', label: '经验分享' },
      { id: '15-22', label: '成功案例' },
    ],
  },
  {
    id: '15-1',
    name: '新手教学',
    keywords: ['新手教学', '新手'],
    text: '请问您是想了解：',
    children: [
      { id: '15-1-1', label: '【视频】猎头全流程' },
      { id: '15-1-2', label: '【音频】做单思路培训' },
      { id: '15-1-3', label: '体系化培训' },
      { id: '15-1-4', label: '【视频】猎头行规&那些不能踩的坑' },
    ],
  },
  {
    id: '15-1-1',
    type: '培训',
    keywords: ['猎头全流程', '猎头流程', '猎头'],
    name: '【视频】猎头全流程',
    attachment: {
      title: '【视频】猎头全流程',
      url: 'https://vod.aconsulting.top/sv/2b1c0f06-1841826cfd5/2b1c0f06-1841826cfd5.mp4',
    },
  },
  {
    id: '15-1-2',
    type: '培训',
    keywords: ['做单思路', '做单', '思路'],
    name: '【音频】做单思路培训',
    attachment: {
      title: '【音频】做单思路培训',
      url: 'https://vod.aconsulting.top/sv/5c8c59fe-1841901ef37/5c8c59fe-1841901ef37.mp3',
    },
  },
  {
    id: '15-1-3',
    type: '培训',
    keywords: ['体系化培训', '体系化'],
    name: '体系化培训',
    attachment: {
      title: '体系化培训',
      type: 'word',
      md5: 'c390d597f5e350bfc03d18d88fc0ba98',
    },
  },
  {
    id: '15-1-4',
    type: '培训',
    keywords: ['猎头行规', '行规', '坑', '注意事项'],
    name: '【视频】猎头行规&那些不能踩的坑',
    attachment: {
      title: '【视频】猎头行规&那些不能踩的坑',
      url: 'https://vod.aconsulting.top/sv/3474af8-1841826a2e6/3474af8-1841826a2e6.mp4',
    },
  },
  // {
  //   id: '15-2',
  //   name: '学习行业认知',
  //   keywords: ['行业认知', '认知'],
  //   text: '请问您是想了解：',
  //   children: [
  //     { id: '15-2-1', label: '职能模块认知模板' },
  //     { id: '15-2-2', label: '【视频】投行行业认知' },
  //     { id: '15-2-3', label: '【视频】公募基金行业认知' },
  //     { id: '15-2-4', label: '【视频】PEVC行业认知' },
  //     { id: '15-2-5', label: '【视频】金融地图' },
  //     { id: '15-2-6', label: '【平安集团&阿尔法咨询】金融行业市场情况分析探讨' },
  //     { id: '14-1-4', label: '如何了解行业' },
  //   ],
  // },
  // {
  //   id: '15-2-1',
  //   type: '培训',
  //   keywords: ['职能模块认知'],
  //   name: '职能模块认知模板',
  //   attachment: {
  //     title: '职能模块认知模板',
  //     type: 'word',
  //     md5: '1638d8606cbcf059452c95d97a87aa79',
  //   },
  // },
  // {
  //   id: '15-2-2',
  //   type: '培训',
  //   keywords: ['投行认知', '投行'],
  //   name: '【视频】投行行业认知',
  //   attachment: {
  //     title: '【视频】投行行业认知',
  //     url: 'https://vod.aconsulting.top/sv/2f951b12-18419226b9f/2f951b12-18419226b9f.mp4',
  //   },
  // },
  // {
  //   id: '15-2-3',
  //   type: '培训',
  //   keywords: ['公募基金认知', '公募基金'],
  //   name: '【视频】公募基金行业认知',
  //   attachment: {
  //     title: '【视频】公募基金行业认知',
  //     url: 'https://vod.aconsulting.top/sv/4c16b914-1841826f6b7/4c16b914-1841826f6b7.mp4',
  //   },
  // },
  // {
  //   id: '15-2-4',
  //   type: '培训',
  //   keywords: ['PEVC认知', 'PEVC'],
  //   name: '【视频】PEVC行业认知',
  //   attachment: {
  //     title: '【视频】PEVC行业认知',
  //     url: 'https://vod.aconsulting.top/sv/6341b437-184182706cb/6341b437-184182706cb.mp4',
  //   },
  // },
  // {
  //   id: '15-2-5',
  //   type: '培训',
  //   keywords: ['金融地图', '金融'],
  //   name: '【视频】金融地图',
  //   attachment: {
  //     title: '【视频】金融地图',
  //     url: 'https://vod.aconsulting.top/sv/350cba1c-18418271820/350cba1c-18418271820.mp4',
  //   },
  // },
  // {
  //   id: '15-2-6',
  //   type: '培训',
  //   keywords: ['市场分析'],
  //   name: '【平安集团&阿尔法咨询】金融行业市场情况分析探讨',
  //   attachment: {
  //     title: '【平安集团&阿尔法咨询】金融行业市场情况分析探讨',
  //     url:
  //       'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E5%B9%B3%E5%AE%89%E9%9B%86%E5%9B%A2%26%E9%98%BF%E5%B0%94%E6%B3%95%E5%92%A8%E8%AF%A2%E3%80%91%E9%87%91%E8%9E%8D%E8%A1%8C%E4%B8%9A%E5%B8%82%E5%9C%BA%E6%83%85%E5%86%B5%E5%88%86%E6%9E%90%E6%8E%A2%E8%AE%A8-4.15.pdf',
  //   },
  // },
  {
    id: '15-3',
    name: '如何开拓新领域',
    keywords: ['开拓新领域', '开拓', '新领域'],
    text: '请问您是想了解：',
    children: [{ id: '15-3-1', label: '【视频】如何开拓新领域' }, { id: '15-3-2', label: '如何快速理解一个陌生行业' }],
  },
  {
    id: '15-3-1',
    type: '培训',
    keywords: ['拓新'],
    name: '【视频】如何开拓新领域',
    attachment: {
      title: '【视频】如何开拓新领域',
      url: 'https://vod.aconsulting.top/sv/5f148c41-184182738c6/5f148c41-184182738c6.mp4',
    },
  },
  {
    id: '15-3-2',
    type: '培训',
    keywords: ['拓新'],
    name: '如何快速理解一个陌生行业',
    attachment: {
      title: '如何快速理解一个陌生行业',
      type: 'word',
      md5: '3a614e9ba7f52655047d2a8f22709b54',
    },
  },
  {
    id: '15-4',
    name: '如何开发客户',
    keywords: ['开发客户', 'bd'],
    text: '请问您是想了解：',
    children: [{ id: '15-4-1', label: '客户BD实用技巧' }, { id: '15-4-2', label: '客户对接' }],
  },
  {
    id: '15-4-1',
    type: '培训',
    keywords: ['客户BD', 'bd'],
    name: '客户BD实用技巧',
    attachment: {
      title: '客户BD实用技巧',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%AE%A2%E6%88%B7BD%E5%AE%9E%E7%94%A8%E6%8A%80%E5%B7%A7%20_20200202.pdf',
    },
  },
  {
    id: '15-4-2',
    type: '培训',
    keywords: ['客户对接', '对接'],
    name: '客户对接',
    attachment: {
      title: '客户对接',
      type: 'word',
      md5: '473eca90f47ff839165c06ebc840caa9',
    },
  },
  {
    id: '15-5',
    name: '如何进行客户会面',
    keywords: ['客户会面', '会面'],
    text: '请问您是想了解：',
    children: [{ id: '15-5-1', label: '【会面须知】客户会面准备模版' }, { id: '3-1', label: '客户会面记录' }],
  },
  {
    id: '15-5-1',
    type: '附件',
    name: '客户会面准备模版',
    label: '【会面须知】客户会面准备模版',
    attachments: [
      {
        title: '【会面须知】客户会面准备模版',
        md5: '02788bb09a32734f06309aade2f2a215',
      },
    ],
  },
  {
    id: '15-6',
    name: '如何快速了解项目',
    keywords: ['项目详情', '项目'],
    text: '请问您是想了解：',
    children: [
      { id: '15-6-1', label: '项目详情分析' },
      { id: '15-6-2', label: '职位分析模版' },
      { id: '15-6-3', label: '项目分类及执行思路' },
      { id: '15-6-4', label: '【视频】人岗匹配之项目详情' },
      { id: '15-6-5', label: '项目详情功能使用教程' },
    ],
  },
  {
    id: '15-6-1',
    type: '培训',
    keywords: ['项目分析'],
    name: '项目详情分析',
    attachment: {
      title: '项目详情分析',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%A1%B9%E7%9B%AE%E8%AF%A6%E6%83%85%E5%88%86%E6%9E%90.pdf',
    },
  },
  {
    id: '15-6-2',
    type: '培训',
    keywords: ['职位分析'],
    name: '职位分析模版',
    attachment: {
      title: '职位分析模版',
      type: 'word',
      md5: '2fe9d1e283619714941eca97c9646861',
    },
  },
  {
    id: '15-6-3',
    type: '培训',
    name: '项目分类及执行思路',
    attachment: {
      title: '项目分类及执行思路',
      type: 'word',
      md5: 'cffbebb613d0f9c1054a1bbe98e9a1d2',
    },
  },
  {
    id: '15-6-4',
    type: '培训',
    keywords: ['人岗匹配'],
    name: '【视频】人岗匹配之项目详情',
    attachment: {
      title: '【视频】人岗匹配之项目详情',
      url: 'https://vod.aconsulting.top/sv/46b9ae22-184182746c9/46b9ae22-184182746c9.mp4',
    },
  },
  {
    id: '15-6-5',
    type: '培训',
    keywords: ['项目详情', '项目'],
    name: '项目详情功能使用教程',
    attachment: {
      title: '项目详情功能使用教程',
      type: 'word',
      md5: '093cfaaf50ae87b9a841adf5b1a7677a',
    },
  },
  {
    id: '15-7',
    name: '如何推动项目',
    keywords: ['项目推动报告', '项目', '推动报告'],
    text: '请问您是想了解：',
    children: [
      { id: '15-7-1', label: '【视频】体系化打法&市场报告' },
      { id: '15-7-2', label: '【模版】项目八股文模版' },
      { id: '15-7-3', label: '人才搜寻报告' },
    ],
  },
  {
    id: '15-7-1',
    type: '培训',
    keywords: ['市场报告'],
    name: '【视频】体系化打法&市场报告',
    attachment: {
      title: '【视频】体系化打法&市场报告',
      url: 'https://vod.aconsulting.top/sv/532ae0ab-18418b5495b/532ae0ab-18418b5495b.mp4',
    },
  },
  {
    id: '15-7-2',
    type: '附件',
    keywords: ['八股文'],
    name: '项目八股文模版',
    label: '【模版】项目八股文模版',
    attachments: [
      {
        title: '【模版】项目八股文模版',
        md5: '8fac7cde27645a3c6cd0cbe8b61e0f6a',
      },
    ],
  },
  {
    id: '15-7-3',
    type: '附件',
    keywords: ['人才搜寻'],
    name: '人才搜寻报告',
    attachments: [
      {
        title: '人才搜寻报告',
        md5: 'a7c69e9215bb4d3285c06e9a3defcf8c',
      },
    ],
  },
  {
    id: '15-8',
    name: '如何进行人才搜索',
    keywords: ['人才搜索', '人才', '搜索'],
    text: '请问您是想了解：',
    children: [{ id: '15-8-1', label: '猎聘领英搜索策略' }, { id: '15-8-2', label: '如何开猎聘账号' }],
  },
  {
    id: '15-8-1',
    type: '培训',
    keywords: ['猎聘', '领英'],
    name: '猎聘领英搜索策略',
    attachment: {
      title: '猎聘领英搜索策略',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E7%8C%8E%E8%81%98%E9%A2%86%E8%8B%B1%E6%90%9C%E7%B4%A2%E7%AD%96%E7%95%A5.pdf',
    },
  },
  {
    id: '15-8-2',
    type: '制度',
    name: '如何开猎聘账号',
    keywords: ['猎聘'],
    text:
      '如何开猎聘账号<br>1、谷歌浏览器上打开以下网址 <a href="https://h.liepin.com/account/login" target="_blank">https://h.liepin.com/account/login</a><br>2、点击 【猎头端】，选择【注册账号】<br>3、注册好账号，挂靠公司【浙江阿尔法人力资源有限公司】<br>4、如果有账号，直接登录<br>5、进入猎聘，找【何佳 ada】领取猎币',
  },
  {
    id: '15-9',
    name: '如何快速筛选简历',
    keywords: ['找人', '简历'],
    text: '请问您是想了解：',
    children: [
      { id: '15-9-1', label: '【操作导图】筛选简历.jpg' },
      { id: '15-9-2', label: '【视频】筛选简历' },
      { id: '15-9-3', label: '【视频】要简历' },
    ],
  },
  {
    id: '15-9-1',
    type: '培训',
    name: '【操作导图】筛选简历.jpg',
    attachment: {
      title: '【操作导图】筛选简历.jpg',
      type: 'img',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%9B%BE%E3%80%91%E7%AD%9B%E9%80%89%E7%AE%80%E5%8E%86.jpg',
    },
  },
  {
    id: '15-9-2',
    type: '培训',
    name: '【视频】筛选简历',
    attachment: {
      title: '【视频】筛选简历',
      url: 'https://vod.aconsulting.top/sv/22621249-18418b53f7c/22621249-18418b53f7c.mp4',
    },
  },
  {
    id: '15-9-3',
    type: '培训',
    name: '【视频】要简历',
    attachment: {
      title: '【视频】要简历',
      url: 'https://vod.aconsulting.top/sv/5b73639-18418b53fc8/5b73639-18418b53fc8.mp4',
    },
  },
  {
    id: '15-10',
    name: '如何打电话',
    keywords: ['打电话', '电话'],
    text: '请问您是想了解：',
    children: [
      { id: '15-10-1', label: '【操作手册】如何克服打电话的心理障碍.pdf' },
      { id: '15-10-2', label: '【操作手册】深度把握人选意向和诉求.pdf' },
      { id: '15-10-3', label: '【操作手册】要简历.pdf' },
      { id: '15-10-4', label: '五部沟通大法' },
      { id: '15-10-5', label: '阿尔法“四会”' },
      { id: '15-10-6', label: '【音频】第一通电话小考' },
      { id: '15-10-7', label: '【模板】第一通电话话术' },
      { id: '15-10-8', label: '【视频】第一通电话' },
      { id: '15-10-9', label: '【视频】猎头流程-电话沟通' },
      { id: '15-10-10', label: '【视频】打电话的四个核心目的' },
      { id: '15-10-11', label: '【视频】如何克服打电话的心理障碍' },
      { id: '15-10-12', label: '第一通电话' },
      { id: '15-10-13', label: '深度把握人选意向和诉求' },
      { id: '15-10-14', label: '如何克服打电话的心理障碍' },
      { id: '15-10-15', label: '【音频】第一通电话' },
      { id: '15-10-16', label: '【场景语言模拟】以某精品投行为例' },
    ],
  },
  {
    id: '15-10-1',
    type: '培训',
    name: '【操作手册】如何克服打电话的心理障碍.pdf',
    attachment: {
      title: '【操作手册】如何克服打电话的心理障碍.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E5%A6%82%E4%BD%95%E5%85%8B%E6%9C%8D%E6%89%93%E7%94%B5%E8%AF%9D%E7%9A%84%E5%BF%83%E7%90%86%E9%9A%9C%E7%A2%8D.pdf',
    },
  },
  {
    id: '15-10-2',
    type: '培训',
    name: '【操作手册】深度把握人选意向和诉求.pdf',
    attachment: {
      title: '【操作手册】深度把握人选意向和诉求.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%B7%B1%E5%BA%A6%E6%8A%8A%E6%8F%A1%E4%BA%BA%E9%80%89%E6%84%8F%E5%90%91%E5%92%8C%E8%AF%89%E6%B1%82.pdf',
    },
  },
  {
    id: '15-10-3',
    type: '培训',
    name: '【操作手册】要简历.pdf',
    attachment: {
      title: '【操作手册】要简历.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E8%A6%81%E7%AE%80%E5%8E%86.pdf',
    },
  },
  {
    id: '15-10-4',
    type: '培训',
    name: '五部沟通大法',
    attachment: {
      title: '五部沟通大法',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E4%BA%94%E9%83%A8%E6%B2%9F%E9%80%9A%E5%A4%A7%E6%B3%95.pdf',
    },
  },
  {
    id: '15-10-5',
    type: '培训',
    name: '阿尔法“四会”',
    attachment: {
      title: '阿尔法“四会”',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%98%BF%E5%B0%94%E6%B3%95%E2%80%9C%E5%9B%9B%E4%BC%9A%E2%80%9D.pdf',
    },
  },
  {
    id: '15-10-6',
    type: '培训',
    name: '【音频】第一通电话小考',
    attachment: {
      title: '【音频】第一通电话小考',
      url: 'https://vod.aconsulting.top/sv/540f0704-18418fe67f6/540f0704-18418fe67f6.mp3',
    },
  },
  {
    id: '15-10-7',
    type: '培训',
    keywords: ['第一通电话'],
    name: '【模板】第一通电话话术',
    attachment: {
      title: '【模板】第一通电话话术',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%A8%A1%E6%9D%BF%E3%80%91%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D%E8%AF%9D%E6%9C%AF.pdf',
    },
  },
  {
    id: '15-10-8',
    type: '培训',
    name: '【视频】第一通电话',
    attachment: {
      title: '【视频】第一通电话',
      url: 'https://vod.aconsulting.top/sv/5c0860e-18418491933/5c0860e-18418491933.mp4',
    },
  },
  {
    id: '15-10-9',
    type: '培训',
    keywords: ['第一通电话'],
    name: '【视频】猎头流程-电话沟通',
    attachment: {
      title: '【视频】猎头流程-电话沟通',
      url: 'https://vod.aconsulting.top/sv/5276b66b-18418b54ca1/5276b66b-18418b54ca1.mp4',
    },
  },
  {
    id: '15-10-10',
    type: '培训',
    name: '【视频】打电话的四个核心目的',
    attachment: {
      title: '【视频】打电话的四个核心目的',
      url: 'https://vod.aconsulting.top/sv/391f5fa6-18418b54ba8/391f5fa6-18418b54ba8.mp4',
    },
  },
  {
    id: '15-10-11',
    type: '培训',
    name: '【视频】如何克服打电话的心理障碍',
    attachment: {
      title: '【视频】如何克服打电话的心理障碍',
      url: 'https://vod.aconsulting.top/sv/417f5b79-1841840c9af/417f5b79-1841840c9af.mp4',
    },
  },
  {
    id: '15-10-12',
    type: '培训',
    keywords: ['第一通电话'],
    name: '第一通电话',
    attachment: {
      title: '第一通电话',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E7%AC%AC%E4%B8%80%E9%80%9A%E7%94%B5%E8%AF%9D.pdf',
    },
  },
  {
    id: '15-10-13',
    type: '培训',
    keywords: ['人选意向', '诉求'],
    name: '深度把握人选意向和诉求',
    attachment: {
      title: '深度把握人选意向和诉求',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%B7%B1%E5%BA%A6%E6%8A%8A%E6%8F%A1%E4%BA%BA%E9%80%89%E6%84%8F%E5%90%91%E5%92%8C%E8%AF%89%E6%B1%82.pdf',
    },
  },
  {
    id: '15-10-14',
    type: '培训',
    name: '如何克服打电话的心理障碍',
    attachment: {
      title: '如何克服打电话的心理障碍',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%A6%82%E4%BD%95%E5%85%8B%E6%9C%8D%E6%89%93%E7%94%B5%E8%AF%9D%E7%9A%84%E5%BF%83%E7%90%86%E9%9A%9C%E7%A2%8D.pdf',
    },
  },
  {
    id: '15-10-15',
    type: '培训',
    keywords: ['第一通电话'],
    name: '【音频】第一通电话',
    attachment: {
      title: '【音频】第一通电话',
      url: 'https://vod.aconsulting.top/sv/18eda8bd-18418fec9a7/18eda8bd-18418fec9a7.mp3',
    },
  },
  {
    id: '15-10-16',
    type: '培训',
    keywords: ['场景模拟'],
    name: '【场景语言模拟】以某精品投行为例',
    attachment: {
      title: '【场景语言模拟】以某精品投行为例',
      url: 'https://vod.aconsulting.top/sv/c34082d-18418ff36bf/c34082d-18418ff36bf.m4a',
    },
  },
  {
    id: '15-11',
    name: '如何Mapping',
    keywords: ['mapping'],
    text: '请问您是想了解：',
    children: [
      { id: '15-11-1', label: 'mapping模板&思维导图' },
      { id: '15-11-2', label: 'mapping方法论' },
      { id: '15-11-3', label: '【视频】项目搜索报告和人才mapping报告' },
      { id: '15-11-4', label: '【视频】mapping的目的' },
      { id: '15-11-5', label: '【视频】前端&后端的配合模式' },
      { id: '15-11-6', label: '【视频】mapping入门' },
      { id: '15-11-7', label: '【视频】mapping演练' },
      { id: '15-11-8', label: '【视频】线人养成' },
    ],
  },
  {
    id: '15-11-1',
    type: '培训',
    name: 'mapping模板&思维导图',
    attachment: {
      title: 'mapping模板&思维导图',
      url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/mapping%E6%A8%A1%E6%9D%BF.jpg',
    },
  },
  {
    id: '15-11-2',
    type: '培训',
    name: 'mapping方法论',
    attachment: {
      title: 'mapping方法论',
      type: 'word',
      md5: '07eb38bf2185f3dcc640467d0aa26ba0',
    },
  },
  {
    id: '15-11-3',
    type: '培训',
    name: '【视频】项目搜索报告和人才mapping报告',
    attachment: {
      title: '【视频】项目搜索报告和人才mapping报告',
      url: 'https://vod.aconsulting.top/sv/10179744-18418b53f84/10179744-18418b53f84.mp4',
    },
  },
  {
    id: '15-11-4',
    type: '培训',
    name: '【视频】mapping的目的',
    attachment: {
      title: '【视频】mapping的目的',
      url: 'https://vod.aconsulting.top/sv/20f01ee4-1841840c9a7/20f01ee4-1841840c9a7.mp4',
    },
  },
  {
    id: '15-11-5',
    type: '培训',
    name: '【视频】前端&后端的配合模式',
    attachment: {
      title: '【视频】前端&后端的配合模式',
      url: 'https://vod.aconsulting.top/sv/460bf38-1841840ca76/460bf38-1841840ca76.mp4',
    },
  },
  {
    id: '15-11-6',
    type: '培训',
    name: '【视频】mapping入门',
    attachment: {
      title: '【视频】mapping入门',
      url: 'https://vod.aconsulting.top/sv/13e7e087-1841841c35d/13e7e087-1841841c35d.mp4',
    },
  },
  {
    id: '15-11-7',
    type: '培训',
    name: '【视频】mapping演练',
    attachment: {
      title: '【视频】mapping演练',
      url: 'https://vod.aconsulting.top/sv/3eaf97a3-1841841e278/3eaf97a3-1841841e278.mp4',
    },
  },
  {
    id: '15-11-8',
    type: '培训',
    name: '【视频】线人养成',
    attachment: {
      title: '【视频】线人养成',
      url: 'https://vod.aconsulting.top/sv/141f266-1841845a762/141f266-1841845a762.mp4',
    },
  },
  {
    id: '15-12',
    name: '如何打标签',
    keywords: ['打标签', '核心标签', '标签'],
    text: '请问您是想了解：',
    children: [
      { id: '15-12-1', label: '【操作手册】打标签.pdf' },
      { id: '15-12-2', label: '【视频】打标签' },
      { id: '15-12-3', label: '打标签培训' },
    ],
  },
  {
    id: '15-12-1',
    type: '培训',
    name: '【操作手册】打标签.pdf',
    attachment: {
      title: '【操作手册】打标签.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%89%93%E6%A0%87%E7%AD%BE.pdf',
    },
  },
  {
    id: '15-12-2',
    type: '培训',
    name: '【视频】打标签',
    attachment: {
      title: '【视频】打标签',
      url: 'https://vod.aconsulting.top/sv/3c0d2873-1841849194d/3c0d2873-1841849194d.mp4',
    },
  },
  {
    id: '15-11-3',
    type: '培训',
    name: '打标签培训',
    attachment: {
      title: '打标签培训',
      type: 'word',
      md5: 'dbfb0dbb19f748829625bce179dc01a2',
    },
  },
  {
    id: '15-13',
    name: '如何帮大佬写推报',
    keywords: ['推报', '推荐报告', '写简历'],
    text: '请问您是想了解：',
    children: [
      { id: '15-13-1', label: '【操作手册】推荐报告的制作.pdf' },
      { id: '15-13-2', label: '【视频】如何制作推荐报告' },
      { id: '15-13-3', label: '【视频】推荐报告' },
      { id: '15-13-4', label: '写简历建议' },
      { id: '15-13-5', label: '【视频】帮大佬写简历' },
      { id: '15-13-6', label: '【视频】如何撰写与发送推荐邮件' },
    ],
  },
  {
    id: '15-13-1',
    type: '培训',
    name: '【操作手册】推荐报告的制作.pdf',
    attachment: {
      title: '【操作手册】推荐报告的制作.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E6%8E%A8%E8%8D%90%E6%8A%A5%E5%91%8A%E7%9A%84%E5%88%B6%E4%BD%9C.pdf',
    },
  },
  {
    id: '15-13-2',
    type: '培训',
    name: '【视频】如何制作推荐报告',
    attachment: {
      title: '【视频】如何制作推荐报告',
      url: 'https://vod.aconsulting.top/sv/37279b12-18418f604c7/37279b12-18418f604c7.mp4',
    },
  },
  {
    id: '15-13-3',
    type: '培训',
    name: '【视频】推荐报告',
    attachment: {
      title: '【视频】推荐报告',
      url: 'https://vod.aconsulting.top/sv/4a3cdc4-18418b54ade/4a3cdc4-18418b54ade.mp4',
    },
  },
  {
    id: '15-13-4',
    type: '培训',
    name: '写简历建议',
    attachment: {
      title: '写简历建议',
      type: 'word',
      md5: '69c8cba6010496444732271c0245b899',
    },
  },
  {
    id: '15-13-5',
    type: '培训',
    name: '【视频】帮大佬写简历',
    attachment: {
      title: '【视频】帮大佬写简历',
      url: 'https://vod.aconsulting.top/sv/33228016-1841848a646/33228016-1841848a646.mp4',
    },
  },
  {
    id: '15-13-6',
    type: '培训',
    name: '【视频】如何撰写与发送推荐邮件',
    attachment: {
      title: '【视频】如何撰写与发送推荐邮件',
      url: 'https://vod.aconsulting.top/sv/37df27d3-18418b53f76/37df27d3-18418b53f76.mp4',
    },
  },
  {
    id: '15-14',
    name: '如何高效进行人选会面',
    keywords: ['人选会面', '会面', '见人'],
    text: '请问您是想了解：',
    children: [
      { id: '15-14-1', label: '【操作手册】人选会面.pdf' },
      { id: '15-14-2', label: '【视频】人选会面' },
      { id: '15-14-3', label: '洞察面试三板斧' },
    ],
  },
  {
    id: '15-14-1',
    type: '培训',
    name: '【操作手册】人选会面.pdf',
    attachment: {
      title: '【操作手册】人选会面.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E4%BA%BA%E9%80%89%E4%BC%9A%E9%9D%A2.pdf',
    },
  },
  {
    id: '15-14-2',
    type: '培训',
    name: '【视频】人选会面',
    attachment: {
      title: '【视频】人选会面',
      url: 'https://vod.aconsulting.top/sv/4a53146f-18418f457d9/4a53146f-18418f457d9.mp4',
    },
  },
  {
    id: '15-14-3',
    type: '培训',
    name: '洞察面试三板斧',
    attachment: {
      title: '洞察面试三板斧',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E6%B4%9E%E5%AF%9F%E9%9D%A2%E8%AF%95%E4%B8%89%E6%9D%BF%E6%96%A7.pdf',
    },
  },
  {
    id: '15-15',
    name: '如何安排面试&面试辅导',
    keywords: ['面试安排', '面试辅导', '面试'],
    text: '请问您是想了解：',
    children: [
      { id: '15-15-1', label: '【操作手册】面试辅导.pdf' },
      { id: '15-15-2', label: '【操作手册】如何安排傲娇候选人面试.pdf' },
      { id: '15-15-3', label: '【视频】面试辅导和安排' },
      { id: '15-15-4', label: '面试反馈SOP' },
      { id: '15-15-5', label: '面试反馈操作手册（最新）' },
      { id: '15-15-6', label: '【视频】面试反馈' },
    ],
  },
  {
    id: '15-15-1',
    type: '培训',
    name: '【操作手册】面试辅导.pdf',
    attachment: {
      title: '【操作手册】面试辅导.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E9%9D%A2%E8%AF%95%E8%BE%85%E5%AF%BC.pdf',
    },
  },
  {
    id: '15-15-2',
    type: '培训',
    name: '【操作手册】如何安排傲娇候选人面试.pdf',
    attachment: {
      title: '【操作手册】如何安排傲娇候选人面试.pdf',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%E3%80%91%E5%A6%82%E4%BD%95%E5%AE%89%E6%8E%92%E5%82%B2%E5%A8%87%E5%80%99%E9%80%89%E4%BA%BA%E9%9D%A2%E8%AF%95.pdf',
    },
  },
  {
    id: '15-15-3',
    type: '培训',
    name: '【视频】面试辅导和安排',
    keywords: ['面试辅导', '面试安排'],
    attachment: {
      title: '【视频】面试辅导和安排',
      url: 'https://vod.aconsulting.top/sv/33714dbb-1841849194a/33714dbb-1841849194a.mp4',
    },
  },
  {
    id: '15-15-4',
    type: '培训',
    name: '面试反馈SOP',
    keywords: ['面试反馈'],
    attachment: {
      title: '面试反馈SOP',
      type: 'word',
      md5: 'a5d9b2c4c69e4f38bdb6d09e8ca1e48c',
    },
  },
  {
    id: '15-15-5',
    type: '培训',
    name: '面试反馈操作手册（最新）',
    keywords: ['面试反馈'],
    attachment: {
      title: '面试反馈操作手册（最新）',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E9%9D%A2%E8%AF%95%E5%8F%8D%E9%A6%88%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%EF%BC%88%E6%9C%80%E6%96%B0%EF%BC%89.pdf',
    },
  },
  {
    id: '15-15-6',
    type: '培训',
    name: '【视频】面试反馈',
    keywords: ['面试反馈'],
    attachment: {
      title: '【视频】面试反馈',
      url: 'https://vod.aconsulting.top/sv/63295d88-18418491959/63295d88-18418491959.mp4',
    },
  },
  {
    id: '15-16',
    name: '如何进行人选背景调查',
    keywords: ['背调', '背景调查'],
    text: '请问您是想了解：',
    children: [{ id: '15-16-1', label: '【视频】背景调查' }, { id: '15-16-2', label: '背景调查' }],
  },
  {
    id: '15-16-1',
    type: '培训',
    name: '【视频】背景调查',
    attachment: {
      title: '【视频】背景调查',
      url: 'https://vod.aconsulting.top/sv/4eaf48fc-18418491951/4eaf48fc-18418491951.mp4',
    },
  },
  {
    id: '15-16-2',
    type: '培训',
    name: '背景调查',
    attachment: {
      title: '背景调查',
      url: 'https://vod.aconsulting.top/sv/82956a1-1841c5a740f/82956a1-1841c5a740f.mp3',
    },
  },
  {
    id: '15-17',
    name: '如何谈offer',
    keywords: ['offer谈判', '谈offer', 'offer'],
    text: '请问您是想了解：',
    children: [
      { id: '15-17-1', label: '如何谈薪.pdf' },
      { id: '15-17-2', label: '【视频】深度把握人选意向和诉求' },
      { id: '15-17-3', label: 'Push&Pull-猎头的本质是思考' },
      { id: '15-17-4', label: '【音频】Push&Pull-猎头的本质是思考' },
      { id: '15-17-5', label: '如何在谈薪博弈中掌握致胜之道' },
      { id: '15-17-6', label: '【视频】薪酬谈判' },
    ],
  },
  {
    id: '15-17-1',
    type: '培训',
    name: '如何谈薪.pdf',
    attachment: {
      title: '如何谈薪.pdf',
      url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%A6%82%E4%BD%95%E8%B0%88%E8%96%AA.pdf',
    },
  },
  {
    id: '15-17-2',
    type: '培训',
    name: '【视频】深度把握人选意向和诉求',
    keywords: ['人选意向', '诉求'],
    attachment: {
      title: '【视频】深度把握人选意向和诉求',
      url: 'https://vod.aconsulting.top/sv/20f5b4c5-1841840c94c/20f5b4c5-1841840c94c.mp4',
    },
  },
  {
    id: '15-17-3',
    type: '培训',
    name: 'Push&Pull-猎头的本质是思考',
    attachment: {
      title: 'Push&Pull-猎头的本质是思考',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E3%80%90%E6%B2%9F%E9%80%9A%E3%80%91Cathy-Push%26Pull-%E7%8C%8E%E5%A4%B4%E7%9A%84%E6%9C%AC%E8%B4%A8%E6%98%AF%E6%80%9D%E8%80%83%20pdf%E7%89%88.pdf',
    },
  },
  {
    id: '15-17-4',
    type: '培训',
    name: '【音频】Push&Pull-猎头的本质是思考',
    attachment: {
      title: '【音频】Push&Pull-猎头的本质是思考',
      url: 'https://vod.aconsulting.top/sv/5a9b2b0b-18418ffb73b/5a9b2b0b-18418ffb73b.m4a',
    },
  },
  {
    id: '15-17-5',
    type: '培训',
    name: '如何在谈薪博弈中掌握致胜之道',
    keywords: ['薪酬谈判', '谈薪'],
    attachment: {
      title: '如何在谈薪博弈中掌握致胜之道',
      type: 'word',
      md5: 'cc48da2db26a6dfdaa1e05d9ace7b0cb',
    },
  },
  {
    id: '15-17-6',
    type: '培训',
    name: '【视频】薪酬谈判',
    keywords: ['薪酬谈判', '谈薪'],
    attachment: {
      title: '【视频】薪酬谈判',
      url: 'https://vod.aconsulting.top/sv/a1cd902-18418b5439a/a1cd902-18418b5439a.mp4',
    },
  },
  {
    id: '15-18',
    name: '如何离职辅导',
    keywords: ['离职辅导', '离职', '辅导'],
    text: '请问您是想了解：',
    children: [{ id: '15-18-1', label: '离职辅导' }, { id: '15-18-2', label: '【视频】如何进行人选离职辅导' }],
  },
  {
    id: '15-18-1',
    type: '培训',
    name: '离职辅导',
    attachment: {
      title: '离职辅导',
      type: 'word',
      md5: 'f4d7c14330ecac6611e70235ce0bbfd3',
    },
  },
  {
    id: '15-18-2',
    type: '培训',
    name: '【视频】如何进行人选离职辅导',
    attachment: {
      title: '【视频】如何进行人选离职辅导',
      url: 'https://vod.aconsulting.top/sv/73bd7e-18418f55103/73bd7e-18418f55103.mp4',
    },
  },
  {
    id: '15-19',
    name: '如何到岗维护',
    keywords: ['到岗维护', '到岗', '维护'],
    text: '请问您是想了解：',
    children: [{ id: '15-19-1', label: '候选人入职跟踪计划表' }],
  },
  {
    id: '15-19-1',
    type: '培训',
    name: '候选人入职跟踪计划表',
    attachment: {
      title: '候选人入职跟踪计划表',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E5%80%99%E9%80%89%E4%BA%BA%E5%85%A5%E8%81%8C%E8%B7%9F%E8%B8%AA%E8%AE%A1%E5%88%92%E8%A1%A8-%E8%AF%97%E4%BA%91.jpg',
    },
  },
  {
    id: '15-20',
    name: '如何获取list',
    keywords: ['list', '通讯录'],
    text: '请问您是想了解：',
    children: [{ id: '15-20-1', label: '如何要list.docx' }, { id: '15-20-2', label: '【视频】如何拿通讯录' }],
  },
  {
    id: '15-20-1',
    type: '培训',
    name: '如何要list.docx',
    attachment: {
      title: '如何要list.docx',
      type: 'word',
      md5: '6a1794156e2147578982b77c6a344023',
    },
  },
  {
    id: '15-20-2',
    type: '培训',
    name: '【视频】如何拿通讯录',
    attachment: {
      title: '【视频】如何拿通讯录',
      url: 'https://vod.aconsulting.top/sv/c457e14-18418f5b53e/c457e14-18418f5b53e.mp4',
    },
  },
  {
    id: '15-21',
    name: '经验分享',
    keywords: ['经验分享', '经验', '分享'],
    text: '请问您是想了解：',
    children: [
      { id: '15-21-1', label: '转推荐步骤表' },
      { id: '15-21-2', label: '争议案例处理方案' },
      { id: '15-21-3', label: '此前推荐人选在猎头未知状态下入职，人选端沟通方案' },
      { id: '15-21-4', label: '【视频】抢人大战' },
      { id: '15-21-5', label: '【视频】直击业务领导' },
      { id: '15-21-6', label: 'Floating的正确打开方式' },
    ],
  },
  {
    id: '15-21-1',
    type: '培训',
    name: '转推荐步骤表',
    keywords: ['转推荐'],
    attachment: {
      title: '转推荐步骤表',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/%E8%BD%AC%E6%8E%A8%E8%8D%90%E6%AD%A5%E9%AA%A4%E8%A1%A8.png',
    },
  },
  {
    id: '15-21-2',
    type: '培训',
    name: '争议案例处理方案',
    keywords: ['归属权', '抢人', '争议'],
    attachment: {
      title: '争议案例处理方案',
      type: 'word',
      md5: '45ec50c979e69ab51584ff79b48df805',
    },
  },
  {
    id: '15-21-3',
    type: '培训',
    name: '此前推荐人选在猎头未知状态下入职，人选端沟通方案',
    keywords: ['归属权', '抢人', '争议'],
    attachment: {
      title: '此前推荐人选在猎头未知状态下入职，人选端沟通方案',
      type: 'word',
      md5: '3e10d7f0651562bbf19967cf8f8633e5',
    },
  },
  {
    id: '15-21-4',
    type: '培训',
    name: '【视频】抢人大战',
    keywords: ['归属权', '抢人', '争议'],
    attachment: {
      title: '【视频】抢人大战',
      url: 'https://vod.aconsulting.top/sv/50e98d6a-18418f399ab/50e98d6a-18418f399ab.mp4',
    },
  },
  {
    id: '15-21-5',
    type: '培训',
    name: '【视频】直击业务领导',
    keywords: ['联系直线', '直线'],
    attachment: {
      title: '【视频】直击业务领导',
      url: 'https://vod.aconsulting.top/sv/23f3052b-18418b54654/23f3052b-18418b54654.mp4',
    },
  },
  {
    id: '15-21-6',
    type: '培训',
    name: 'Floating的正确打开方式',
    keywords: ['floating'],
    attachment: {
      title: 'Floating的正确打开方式',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/public/records/Floating%E7%9A%84%E6%AD%A3%E7%A1%AE%E6%89%93%E5%BC%80%E6%96%B9%E5%BC%8F-Jessica.jpg',
    },
  },
  {
    id: '15-22',
    name: '成功案例',
    keywords: ['成功案例', '成功', '案例'],
    text: '请问您是想了解：',
    children: [
      { id: '15-22-1', label: '医药BD职能模块&case分享' },
      { id: '15-22-2', label: 'offer谈判—GY量化负责人职位复盘' },
    ],
  },
  {
    id: '15-22-1',
    type: '培训',
    name: '医药BD职能模块&case分享',
    attachment: {
      title: '医药BD职能模块&case分享',
      type: 'word',
      md5: '107985c829130f7eee9274ca8ab18941',
    },
  },
  {
    id: '15-22-2',
    type: '培训',
    name: 'offer谈判—GY量化负责人职位复盘',
    keywords: ['offer谈判', '职位复盘'],
    attachment: {
      title: 'offer谈判—GY量化负责人职位复盘',
      type: 'word',
      md5: '5c099f4692d12bc70f983c4614e299aa',
    },
  },
  // 制度
  {
    id: '16',
    name: '公司制度',
    text: '请问您具体想知道什么制度：',
    keywords: ['制度'],
    children: [
      { id: '16-1', label: '寄公司快递' },
      { id: '16-3', label: '报销' },
      { id: '16-5', label: '如何上社保' },
      { id: '16-4', label: '考核制度' },
      { id: '16-6', label: '薪酬激励' },
      { id: '16-11', label: '薪酬绩效' },
      { id: '16-7', label: '行为规范' },
      { id: '16-2', label: '考勤与请假' },
      { id: '16-8', label: '离职' },
      { id: '16-9', label: '员工手册' },
      { id: '16-10', label: '赛道AB角' },
    ],
  },
  {
    id: '16-1',
    type: '制度',
    name: '寄公司快递',
    keywords: ['快递', '寄', '月结', '顺丰'],
    text: '咱们工作上需要寄快递可以使用下面的顺丰月结哦～<br>顺丰月结号：0100108646',
  },
  {
    id: '16-2',
    name: '考勤与请假',
    text: '请问您是想问：',
    keywords: ['休假', '假期', '放假', '考勤', '打卡'],
    children: [
      { id: '16-2-1', label: '阿尔法咨询员工考勤与休假管理办法' },
      { id: '16-2-2', label: '请假细则' },
      { id: '16-2-3', label: '旷工行为认定' },
      { id: '16-2-4', label: '考勤打卡' },
      { id: '16-2-5', label: '考勤工资条' },
    ],
  },
  {
    id: '16-2-1',
    type: '培训',
    name: '阿尔法咨询员工考勤与休假管理办法',
    keywords: ['请假', '休假', '假期', '放假', '考勤', '打卡'],
    attachment: {
      title: '阿尔法咨询员工考勤与休假管理办法_20221025095945.pdf',
      type: 'word',
      md5: 'be6bb4b3851c01deb5032c6f5497d115',
    },
  },
  {
    id: '16-2-2',
    type: '制度',
    name: '请假细则',
    keywords: ['请假', '休假'],
    text:
      '请假细则 <br>（1）员工申请假期时，应提前提出申请， 假期≤2 天，提前 1 天在钉钉提交审批； 假期＞2 天，提前 3 天告知主管并在钉钉提交审批，并安排好工作交接； <br>（2）年假和病假均可以最小 0.5 天为单位请假； <br>（3）如遇特殊情况未请假，先告知主管与人事行政部门，后续在平台补请；<br>（4）请假审批流程：通过钉钉提交请假申请-经由公司部门负责人批准-可休 假-批准后会自动抄送人事行政部备案；请假＞2 天的-先通过部门负责人或签批 准-总经理批准-抄送人事行政部门备案； <br>（5）员工请假优先扣除年假与带薪病假',
  },
  {
    id: '16-2-3',
    type: '制度',
    name: '旷工行为认定',
    keywords: ['旷工'],
    text:
      '旷工行为认定 <br>（1）工作时间开始后 60 分钟后到岗或工作时间结束前 60 分钟离岗视为旷工 半天。 <br>（2）工作时间开始 4 小时以后到岗或工作结束 4 小时以前离岗视为旷工一 天。 <br>（3）无任何手续无故不上班或无故请假未获批准不到岗上班的。<br>（4）请假期满，未续假或续假未获准而逾期不归的。 <br>（5）委托他人打卡及代他人打卡，伪造出勤记录。 <br>（6）公司依法扣除员工旷工日的工资与补贴，员工一年旷工达到三天时，公司 有权进行辞退',
  },
  {
    id: '16-2-4',
    type: '制度',
    name: '考勤打卡',
    keywords: ['打卡', '考勤', '外出'],
    text: '出门办事别忘了考勤打卡：<br>会面前在钉钉提交外出申请<br>申请路径：钉钉-工作台-外出-在核心系统填写会面记录',
  },
  {
    id: '16-2-5',
    type: '制度',
    name: '考勤工资条',
    keywords: ['工资', '考勤'],
    text:
      '我来教您怎么看自己的工资条吧～<br>确认路径：钉钉-底部中间阿尔法logo-下拉找到智能工资条-我的-找到当月考勤工资条确认无误后—点击确认<br>发放时间：每月5号为薪资发放日，考勤薪资条提前2-3天发放，关注工作大群的通知哦',
  },
  {
    id: '16-3',
    name: '报销',
    text: '请问您是想问：',
    children: [
      { id: '16-3-7', label: '报销-财务报销手册'},
      { id: '16-3-1', label: '报销-路径' },
      { id: '16-3-6', label: '报销-注意事项' },
      { id: '16-3-2', label: '报销-发票' },
      { id: '16-3-4', label: '报销-报销时间' },
      { id: '16-3-5', label: '报销-报销标准' },
    ],
  },
  {
    id: '16-3-7',
    type: '附件',
    name: '财务报销手册',
    keywords: ['报销'],
    attachments: [
      {
        title: '财务报销手册.xlsx',
        md5: 'd0c51cbf81e051c3512f7235b433ef8f',
      },
    ],
  },
  {
    id: '16-3-1',
    type: '培训',
    name: '报销-路径',
    keywords: ['报销'],
    attachment: {
      title: '报销路径',
      url:
        'https://vod.aconsulting.top/sv/81f3f61-18769f4a115/81f3f61-18769f4a115.mp4',
    },
  },
  {
    id: '16-3-2',
    type: '制度',
    name: '报销-发票',
    keywords: ['发票', '报销'],
    text:
      '报销-发票<br>请开自己社保公司的发票，确保抬头无误。<br>发票抬头如下：<br>（抬头有误不予报销哦~）<br><br>企业名称：浙江阿尔法人力资源有限公司<br>纳税识别号：91330521344023513A<br>地址、电话：浙江省湖州市德清县康乾街道图强路1号智能生态城2幢404-1号（自主申报）13910632081<br>开户行及账号：招商银行股份有限公司湖州德清支行 572900225610716<br><br>企业名称：北京阿尔法智人科技有限公司<br>纳税识别号：91110105MA00B5RG30<br>地址、电话：北京市朝阳区亮马桥路32号4层508 010-84463083<br>开户行及账号：招商银行股份有限公司北京分行东三环支行 110926454310902<br><br>企业名称：浙江阿尔法人力资源有限公司北京分公司<br>纳税识别号：91110105MA01B7M90R<br><br>企业名称：浙江阿尔法人力资源有限公司上海分公司<br>纳税识别号：91310120MA1HX7WX7T<br><br>公司名称：佛山市智招科技有限公司<br>纳税识别号：91440605MA55R2M11G<br><br>企业名称：浙江微元智能科技股份有限公司<br>纳税识别号：91330500MA2B7G9346<br>地址、电话：浙江省湖州市南浔区南浔镇朝阳路666号南浔科技创业园一层1058室 0572-8270622<br>开户行及账号：中国建设银行股份有限公司德清支行营业部 33050164732700001016<br><br>企业名称：山东阿尔法猎人科技有限公司<br>纳税识别号：91370783MA9431W42W',
  },
  // {
  //   id: '16-3-3',
  //   type: '制度',
  //   name: '报销-团队报销申请表及填写要求',
  //   keywords: ['报销申请', '报销单', '报销审批', '报销'],
  //   text: '不知道怎么填报销单吗？看看下面的附件',
  //   children: [
  //     { id: '16-3-3-1', label: '报销-团队报销申请表填写要求' },
  //     { id: '16-3-3-2', label: '模板团队报销申请表' },
  //   ],
  // },
  // {
  //   id: '16-3-3-1',
  //   type: '其他',
  //   name: '团队报销申请表填写要求',
  // },
  // {
  //   id: '16-3-3-2',
  //   type: '附件',
  //   name: '模板团队报销申请表',
  //   attachments: [
  //     {
  //       title: '模板团队报销申请表1.xlsx',
  //       md5: 'd2f99dabbb9a59c338ed7e4e706d67c2',
  //     },
  //   ],
  // },
  {
    id: '16-3-4',
    type: '制度',
    name: '报销-报销时间',
    keywords: ['报销时间', '报销发放', '报销'],
    text:
      '报销-时间<br>①钉钉提报截止时间：每月15号下午18:30（遇节假日提前，以工作群通知为准）<br>②纸质材料提交截止时间：每月16号下午18:30<br>③费用发放时间：每月18号（遇节假日延后发放）',
  },
  {
    id: '16-3-5',
    type: '制度',
    name: '报销-报销标准',
    keywords: ['报销标准', '报销'],
    text:
      '公司的报销标准还是不错的：<br>【差旅费】<br>1、交通：火车（二等座/硬卧/硬座）；飞机（经济舱）；大巴车；同城出租车/网约车（优享及以下档次）/地铁。<br>2、住宿：签约酒店优先。如非签约酒店，北京，上海，各省会及沿海发达开放的一级城市的酒店住宿标准最高为人民币400元/天；二级城市的酒店住宿标准为最高人民币350元/天，其余城市一律封顶300元/天。若员工前往出差的城市2人及以上同性别两人住宿同一房间。<br>【业务往来费】<br>1、车费：往返约见地点的交通费（标准同差旅）；优先级：地铁/公交>网约车（快车）>出租车>专车（神州租车、礼橙专车等）；<br>2、餐费：和候选人、客户吃饭的餐费可报销（茶歇类：人均最高50元；餐饮类；人均最高80元）<br><span style="color:red">**注意事项：所有候选人见面、客户见面需依据系统有对应上传的会面记要等文字记录通过审批。</span><br>3、其他：视具体情况而定，与行政组对接。',
  },
  {
    id: '16-3-6',
    type: '制度',
    name: '报销-注意事项',
    keywords: ['报销'],
    text:
      '报销-注意事项<br>①发票超过5张请打包上传<br>②团队统一报销，报销款项将直接分别打入报销人的个人账户，不会统一发给提请报销的人。（请务必填写好钉钉银行卡信息：银行卡号、开户行（开户行具体到支行））<br>③北京同事自行打印发票，并标注好发票属人，现场提交给行政小姐姐，非北京同事提交电子版，纸质发票统一收集、标注好属人，统一邮寄北京（邮寄地址：北京市朝阳区亮马桥街道32号高斓大厦5层503  张天一 19953430806）<br><br>【有以下情况，审批不予通过】<br>①会面报销，未在钉钉提交会面记录<br>②发票金额少于报销金额<br>③发票抬头有误<br>④申请的报销公司与本人社保公司不一致（不确定自己社保公司的请查看工资条，仍不明确把或有疑问的，可咨询行政小姐姐）<br>⑤超时未提交<br>⑥未提交《团队报销申请表》<br>⑦发票图片极其不清晰，财务无法入账',
  },
  {
    id: '16-4',
    type: '制度',
    name: '考核制度',
    keywords: ['考核制度', '考核', '复盘'],
    text: '不知道考核制度吗？看看下面的附件',
    children: [{ id: '16-4-1', label: '考核和晋升制度' }, { id: '16-4-2', label: '阿尔法百万顾问训练营' }],
  },
  {
    id: '16-4-1',
    type: '培训',
    name: '考核和晋升制度',
    attachment: {
      title: '考核和晋升制度(16象限).pptx',
      type: 'word',
      md5: 'a7e891c500764ef5577fe249c9ffac37',
    },
  },
  {
    id: '16-4-2',
    type: '培训',
    name: '阿尔法百万顾问训练营',
    keywords: ['百万顾问'],
    attachment: {
      title: '阿尔法百万顾问训练营.pdf',
      type: 'word',
      md5: 'ccbb63b8e10df3033269338ebb6a9b5d',
    },
  },
  {
    id: '16-5',
    type: '制度',
    name: '如何上社保',
    keywords: ['社保'],
    text:
      '没上社保的小伙伴别忘了上社保～<br>每月10号前入职且已拿到毕业证的小伙伴可以当月上社保，之后入职的小伙伴次月上社保<br><br>提供材料到行政部门：<br>北京地区：下载《北京市社会保险个人信息登记表》并填写完成 ，身份证扫描件和1寸白底免冠照片<br><br>上海、长沙、广州的小伙伴：下载《社保增员登记表》并填写完成，提供身份证扫描件',
  },
  {
    id: '16-6',
    type: '制度',
    name: '薪酬激励',
    keywords: ['薪酬激励', '激励机制', '薪酬', '激励'],
    text: '不知道薪酬激励吗？看看下面的附件',
    children: [
      { id: '16-6-1', label: '两年快速合伙人计划【22年申请有效】' },
      { id: '16-6-2', label: '关于客户经理拿独家大单的特殊激励' },
    ],
  },
  {
    id: '16-6-1',
    type: '话术模板',
    name: '两年快速合伙人计划',
    keywords: ['合伙人'],
    content:
      '长期激励：两年合伙人计划 \n\n终极合伙人计划：个人 300 万，或团队 500 万。 \n\n两年快速晋升合伙人计划：从 2022 年开始，到 2023 年，为期两年。 \n\n针对个人业绩强者和团队管理强者有两种不同方案，其中： \n个人冲业绩方案：连续两年个人业绩两百万以上 \n团队管理方案：每带出一个百万顾问，升合伙人的年度业绩目标就减少 \n50w 1、 个人 250 万，带出一位百万顾问； \n2、个人 200 万，带出两位百万顾问； \n3、个人 150 万，带出三位百万顾问； \n4、个人 100 万，带出四位百万顾问。 \n\n注明： \n1、其中个人业绩取两年中高的一年，但是单年度个人业绩不能低于百万，维持百万顾问的底线； \n2、带出的百万顾问数量，为两年内累计带出的百万顾问数来定； \n3、业绩以 offer 业绩为准，如有掉 offer 的情况在核算时自动从业绩中减去，同时，我们会 定期 review 人选到岗和试用期情况。 \n\n申请条件： \n① 已经解锁 100w 业绩目标的成熟顾问，个人通过试用期考核已经转正，体系化积分达标；\n② 成为某职能模块的项目经理；\n③ BD 成功过 1 个客户',
  },
  {
    id: '16-6-2',
    type: '培训',
    name: '关于客户经理拿独家大单的特殊激励',
    attachment: {
      title: '关于客户经理拿独家大单的特殊激励2022年年内有效.pdf',
      type: 'word',
      md5: '640dee44c9bbefe83554074bd138837c',
    },
  },
  {
    id: '16-7',
    type: '制度',
    name: '行为规范',
    keywords: ['行为规范', '行为', '规范'],
    text: '不知道行为规范吗？看看下面的附件',
    children: [{ id: '16-7-1', label: '阿尔法咨询内部推荐奖励机制' }, { id: '16-7-2', label: '阿尔法驾照规则' }],
  },
  {
    id: '16-7-1',
    type: '培训',
    name: '阿尔法咨询内部推荐奖励机制',
    keywords: ['内推'],
    attachment: {
      title: '阿尔法咨询内部推荐奖励机制.xlsx',
      type: 'word',
      md5: 'e2092f8fbb1b8cb7bc58cd9d6be9c628',
    },
  },
  {
    id: '16-7-2',
    type: '培训',
    name: '阿尔法驾照规则',
    keywords: ['驾照'],
    attachment: {
      title: '阿尔法驾照规则.pdf',
      type: 'word',
      md5: '468113318f25da64f7293fb62f0a0e07',
    },
  },
  {
    id: '16-8',
    type: '制度',
    name: '离职',
    keywords: ['离职'],
    text: '看看下面的附件',
    children: [{ id: '16-8-1', label: '离职申请审批表' }, { id: '16-8-2', label: '离职交接清单' }],
  },
  {
    id: '16-8-1',
    type: '附件',
    name: '离职申请审批表',
    attachments: [
      {
        title: '离职申请审批表.docx',
        md5: '44e5fe8074afa1e6227b20970141b861',
      },
    ],
  },
  {
    id: '16-8-2',
    type: '附件',
    name: '离职交接清单',
    attachments: [
      {
        title: '离职交接清单.xlsx',
        md5: 'a1a45038f8125e76711af4018cbc9b8e',
      },
    ],
  },
  {
    id: '16-9',
    type: '培训',
    name: '浙江阿尔法人力资源有限公司员工手册',
    keywords: ['员工手册'],
    attachment: {
      title: '浙江阿尔法人力资源有限公司员工手册',
      type: 'word',
      md5: '3aa3869cf421aed1b30ecf45ef8c9faa',
    },
  },
  {
    id: '16-10',
    type: '培训',
    name: '赛道AB角',
    keywords: ['赛道ab角', 'ab角', '赛道划分', 'ab'],
    attachment: {
      title: '赛道AB角',
      url:
        'https://alphahr.oss-cn-beijing.aliyuncs.com/document/upload/ab.jpeg',
    },
  },
  {
    id: '16-11',
    type: '培训',
    name: '薪酬体系绩效考核',
    keywords: ['薪酬', '绩效'],
    attachment: {
      title: '薪酬体系绩效考核.pdf',
      type: 'word',
      md5: '38dc859a21576f975c1662cca00ff3d3',
    },
  },
  {
    id: '17-1',
    type: '话术模板',
    name: '面试安排',
    label: '面试安排模板',
    keywords: ['面试安排', '模板'],
    hasStyle: true,
    content: `<p>
    <div style="color:#888">面试问询：</div>
    <div style="padding:10px">【***】岗位<br>【人选姓名（现任公司）】<br>1）可面试时间：【】<br>2）行程/特殊情况：【】<br>3）联系方式：【】<br><br>感谢您的大力推进！<br><br>阿尔法咨询<br></div>
    <div style="color:#888">面试确认to人选：</div>
    <div style="padding:10px">****公司  ****职位<br>1）面试时间：【】<br>2）面试官：【】<br>3）面试地点：【】<br>4）面试联系人：【】<br>5）联系方式：【】<br><br>其余注意事项：【根据具体客户要求进行提示，例如带身份证件、原始简历等】<br><br>祝您沟通愉快，有任何问题随时联系我~<br></div>
    <div style="color:#888">面试确认to客户：</div>
    <div style="padding:10px">【面试确认to客户】*****岗位<br>【人选姓名（现任公司）】<br>1）面试时间：【】<br>2）面试官：【】<br>3）面试地点：【】<br>4）人选联系方式：【】<br>5）面试联系人：【】<br>6）联系方式：【如果不需要跟客户确认就可以不用填】<br><br>感谢您的大力推进！<br><br>阿尔法咨询<br></div>
    </p>`,
  },
  {
    id: '17-2',
    type: '话术模板',
    name: '面试反馈',
    label: '面试反馈模板',
    keywords: ['面试反馈', '模板'],
    hasStyle: true,
    content: `<p>
    <div style="color:#888">面试反馈to客户：</div>
    <div style="padding:10px">【面试反馈】-XXX岗位-人选姓名（现任公司）<br>面试官：【】<br>面试时长：【】<br>面试内容：【】<br>人选意向：【非常积极/积极/犹豫需要推动/人选放弃】<br>人选诉求：【】<br>人选动因：【】<br>人选目前薪酬：【】<br>人选目前职级：【】<br>离职周期：【】<br>预计到岗时间：【】<br>风险点：【】<br>人选目前其他offer：【】<br>推进建议：【】<br></div>
    <div style="color:#888">面试反馈to人选：</div>
    <div style="padding:10px">【面试反馈】- XXX 岗位-人选姓名（现任公司）<br>面试内容：【聊了多长时间，聊了哪些问题（项目经历，未来的展业规划等）】<br>面试官对人选的评价和接下来的安排：【】<br>面试官：【】<br>面试时长：【】<br>人选意向：【非常积极/积极/犹豫需要推动/人选放弃】<br>人选诉求：【】<br>人选动因：【】<br>人选目前薪酬：【】<br>人选目前职级：【】<br>离职周期：【】<br>预计到岗时间：【】<br>风险点：【】<br>人选目前其他offer：【】<br>推进建议：【】<br></div>
    </p>`,
  },
  {
    id: '17-3',
    type: '附件',
    name: '每日复盘模板',
    keywords: ['每日复盘', '复盘'],
    attachments: [
      {
        title: '每日复盘模板',
        md5: '9ffaa0e75cde7b93260607b4f78f0103',
      },
    ],
  },
  {
    id: '17-4',
    type: '附件',
    name: '项目进展review',
    label: '项目进展review模板',
    keywords: ['项目进展', 'review'],
    attachments: [
      {
        title: '项目进展review表格模板',
        md5: '3f5b6f02777e960dcb2c9f23382ba3e7',
      },
    ],
  },
  {
    id: '18',
    path: 'bulletins',
    name: '进入情报系统',
    keywords: ['情报', '资讯'],
    isLink: true,
  },
  {
    id: '19',
    type: '培训',
    name: '学校list',
    keywords: ['学校'],
    text: '请问您要查看哪一个',
    attachments: [
      {
        title: '建投学校',
        type: 'word',
        md5: 'dc33431ffa1dd37a20adbb9fb504ad60',
      },
      {
        title: '中信学校',
        type: 'word',
        md5: '7836a34fd9de0feac8fcfdc346a4b912',
      },
    ],
  },
  {
    id: '20-1',
    name: '新增人选',
    keywords: ['简历上传', '新增人选', '简历'],
  },
  {
    id: '20-2',
    name: '新增通讯录',
    keywords: ['list上传', '通讯录上传', '新增通讯录'],
  },
  {
    id: '20-3',
    name: '新增职能模块报告',
    keywords: ['职能模块报告'],
    path: 'knowledgebase?tab=阿尔法出品报告',
    isLink: true,
  },
]
export { answers }
